const linkStyle = {
  color: "#0d47a1",
  textDecoration: "none",
  borderBottom: "1px solid #0d47a1",
};

export const glossaryData = [
  {
    term: "1.5 Degrees Celsius Global Temperature Rise",
    definition: (
      <>
        The scientific consensus regarding the point in temperature rise past
        which the worst impacts of global climate change begin, from wholesale
        coral reef destruction and sea level rise to irreversible tipping points
        across natural systems worldwide.
        <br />
        <br />
        <em>Source:</em> The Climate Reality Project. “Why Is 1.5 Degrees the
        Danger Line for Global Warming?” Climate Reality, May 2020.{" "}
        <a
          href="https://www.climaterealityproject.org/blog/why-15-degrees-danger-line-global-warming"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Active Clients",
    definition: (
      <>
        Individuals, groups, or organizations that are active users of the
        organization's services. For example, active financial services clients
        may include those with active credit or savings accounts (excluding
        remittances or other financial transactions) or clients who have had
        transactions with microfinance institutions (MFI) during the reporting
        period. The definition of active may vary by product. For example, for
        traditional services, “active” typically includes all individuals who
        have accounts registered in their names for at least six months and who
        have used their accounts to make transactions within the prior six
        months. For digital services, “active” typically includes individuals
        who have had accounts registered in their names for at least three
        months and who have used their accounts to make transactions within the
        prior three months.
        <br />
        <br />
        <em>Sources:</em> CGAP's Number of Active Clients definition{" "}
        <a
          href="http://www.cgap.org/sites/default/files/CGAP-Consensus-Guidelines-Definitions-of-Selected-Financial-Terms-Ratios-and-Adjustments-for-Microfinance-Sep-2003.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        and the GIIN's Navigating Impact project.
      </>
    ),
  },
  {
    term: "Adaptive Capacity",
    definition: (
      <>
        Adaptive capacity is the potential or ability of a system, region, or
        community to adapt to the effects or impacts of climate change.
        <br />
        <br />
        <em>Source:</em> Intergovernmental Panel on Climate Change.{" "}
        <a
          href="https://archive.ipcc.ch/ipccreports/tar/wg2/index.php?idp=643"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Affordable Housing",
    definition: (
      <>
        Housing for which the associated financial costs are at a level that
        does not threaten or compromise the occupants' enjoyment of other human
        rights and basic needs and that represents a reasonable proportion of an
        individual's overall income.
        <br />
        <br />
        <em>Source:</em> Adapted from the United Nations Human Rights
        Commission.{" "}
        <a
          href="http://www.ohchr.org/Documents/Publications/FS21_rev_1_Housing_en.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Agricultural Finance",
    definition: (
      <>
        Provision of financial services that support all agriculture-related
        activities, including those of processors, distributors, and exporters
        who may be located in rural, urban or peri-urban areas.
        <br />
        <br />
        <em>Source:</em> ILO, Empowering rural communities through financial
        inclusion.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---ed_emp/documents/publication/wcms_159004.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Agricultural Land",
    definition: (
      <>
        Agricultural Land may be defined broadly as land used primarily for
        production of food and fiber. Agricultural land subcategories identified
        in the Anderson Land Classification system include cropland and pasture;
        orchards, groves, vineyards, nurseries, and ornamental horticultural
        areas; confined feeding operations; and other agricultural land.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System.{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Agricultural Value Chain",
    definition: (
      <>
        The set of actors and activities that bring a basic agricultural product
        from production in the field to final consumption, where at each stage
        value is added to the product. A value chain can be a vertical linking
        or a network between various independent business organizations and can
        involve processing, packaging, storage, transport and distribution. The
        terms “value chain” and “supply chain” are often used interchangeably.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United
        Nations.{" "}
        <a
          href="https://www.fao.org/3/i2008e/i2008e04.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Agroforestry",
    definition: (
      <>
        The intentional integration of trees and shrubs into crop and animal
        farming systems to create environmental, economic, and social benefits.
        <br />
        <br />
        <em>Source:</em> “Agroforestry,” U.S. Department of Agriculture (USDA).{" "}
        <a
          href="https://www.usda.gov/topics/forestry/agroforestry"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Allocation Regime",
    definition: (
      <>
        The combination of policies, mechanisms, and governance arrangements
        (entitlements, licenses, permits, etc.) used to determine who is allowed
        to abstract water from a resource pool, how much may be taken and when,
        as well as how much must be returned (of what quality), and the
        conditions associated with the use of this water.
        <br />
        <br />
        <em>Source:</em> OECD. Water Resources Allocation: Sharing Risks and
        Opportunities. OECD Studies on Water. Paris: OECD Publishing, 2015.{" "}
        <a
          href="https://doi.org/10.1787/9789264229631-en"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Alternative Fuels",
    definition: (
      <>
        Alternative fuels are fuels other than gasoline for powering motor
        vehicles, such as natural gas, methanol, or electricity.
        <br />
        <br />
        <em>Source:</em> “Alternative Fuels.” www.fueleconomy.gov - the official
        government source for fuel economy information.{" "}
        <a
          href="https://www.fueleconomy.gov/feg/current.shtml"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Aquaculture",
    definition: (
      <>
        Aquaculture, also known as aquafarming, is the farming of fish,
        crustaceans, mollusks, aquatic plants, algae, and other organisms.
        Aquaculture involves cultivating freshwater and saltwater populations
        under controlled conditions, and can be contrasted with commercial
        fishing, which is the harvesting of wild fish.
        <br />
        <br />
        <em>Source:</em> US Department of Commerce, National Oceanic and
        Atmospheric Administration. “What Is Aquaculture?” NOAA's National Ocean
        Service, April 2019.{" "}
        <a
          href="https://oceanservice.noaa.gov/facts/aquaculture.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Asset",
    definition: (
      <>
        A resource controlled by an entity as a result of past events; and from
        which future economic benefits are expected to flow to the entity.
        <br />
        Anything tangible or intangible that is capable of being owned or
        controlled to produce value and that is held to have positive economic
        value is considered an asset. Simply stated, assets represent ownership
        of value that can be converted into cash (although cash itself is also
        considered an asset).
        <br />
        <br />
        <em>Source:</em> International Financial Reporting Standards.{" "}
        <a
          href="http://ifrs.wiley.com/glossary/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Avoided Forest Conversion",
    definition: (
      <>
        A natural climate solution where the carbon sequestration is determined
        by the forest that avoids getting converted to another type of land-use,
        such as a plantation or agricultural land.
        <br />
        <br />
        <em>Source:</em> Griscom, Bronson W., Justin Adams, Peter W. Ellis,
        Richard A. Houghton, Guy Lomax, Daniela A. Miteva, William H.
        Schlesinger et al. “Natural Climate Solutions.” Proceedings of the
        National Academy of Sciences 114, no. 44 (October 31, 2017): 11645–650.
      </>
    ),
  },
  {
    term: "Barren Land",
    definition: (
      <>
        Barren land is land of limited ability to support life and in which less
        than one-third of the area has vegetation or other cover. In general, it
        is an area of thin soil, sand, or rocks. Vegetation, if present, is more
        widely spaced and scrubby than that in the Shrub and Brush category of
        Rangeland. Unusual conditions, such as a heavy rainfall, occasionally
        result in growth of a short-lived, more luxuriant plant cover. Wet,
        nonvegetated barren lands are included in the Nonforested Wetland
        category.
        <br />
        <br />
        Barren land subcategories identified in the Anderson Land Classification
        system include: dry salt flats, beaches, and sandy areas other than
        beaches; bare exposed rock; strip mines, quarries, and gravel pits;
        transitional areas; and mixed barren land.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System.{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Basic Hygiene",
    definition: (
      <>
        Water and soap or disinfectant hand rub available at points of care and
        within five meters of toilets.
        <br />
        <br />
        <em>Source:</em> World Health Organization (WHO) and UNICEF Joint
        Monitoring Programme. WASH in Health Care Facilities: Global Baseline
        Report 2019. Geneva: WHO, 2019.
      </>
    ),
  },
  {
    term: "Basic Sanitation",
    definition: (
      <>
        Use of sanitation facilities which are not shared with other households
        and that ensure hygienic separation of excreta from human contact.
        <br />
        <br />
        In the context of healthcare facilities, basic sanitation refers to
        improved, usable sanitation facilities, with at least one toilet
        dedicated for staff, at least one sex-separated toilet with menstrual
        hygiene facilities, and at least one toilet accessible for people with
        limited mobility.
        <br />
        <br />
        <em>Sources:</em>{" "}
        <a
          href="https://www.who.int/en/news-room/fact-sheets/detail/sanitation"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          World Health Organization. “Sanitation.” Fact sheet, June 14, 2019.
        </a>
        <br />
        World Health Organization (WHO) and UNICEF Joint Monitoring Programme.
        WASH in Health Care Facilities: Global Baseline Report 2019. Geneva:
        WHO, 2019.
      </>
    ),
  },
  {
    term: "Basic Water",
    definition: (
      <>
        "Basic water" refers to drinking water from a source that protects
        against outside contamination—especially fecal matter—where collection
        time is not more than 30 minutes roundtrip (including queueing).
        <br />
        <br />
        In the context of healthcare facilities, basic water refers to water
        available from an improved source on the premises.
        <br />
        <br />
        <em>Sources:</em>{" "}
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/drinking-water"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          World Health Organization. “Drinking-Water.” Fact sheet, June 14,
          2019.
        </a>
        <br />
        World Health Organization (WHO) and UNICEF Joint Monitoring Programme.
        WASH in Health Care Facilities: Global Baseline Report 2019. Geneva:
        WHO, 2019.
      </>
    ),
  },
  {
    term: "Benefit Corporation",
    definition: (
      <>
        Benefit Corporations are a new class of corporation that 1) creates a
        material positive impact on society and the environment; 2) expands
        fiduciary duty to require consideration of non-financial interests when
        making decisions; and 3) reports on its overall social and environmental
        performance using recognized third-party standards.
        <br />
        <br />
        <em>Source:</em> Benefit Corp Information Center.{" "}
        <a
          href="http://benefitcorp.net/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Bias",
    definition: (
      <>
        Prejudice, preference, predisposition or inclination towards or against
        one thing, person or group relative to others, often based on prevailing
        stereotypes.
        <br />
        <br />
        <em>Source:</em> Criterion Institute.{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Biocredits",
    definition: (
      <>
        Biocredits are an economic instrument that can be used to finance
        biodiversity-enhancing actions (such as protecting or restoring species,
        ecosystems or natural habitats) through the creation and sale of
        biodiversity units.
        <br />
        <br />
        <em>Source:</em> Porras, Ina, and Paul Steele. "Making the market work
        for nature." Economics (2020).{" "}
        <a
          href="https://pubs.iied.org/sites/default/files/pdfs/migrate/16664IIED.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Biodegradable",
    definition: (
      <>
        Capable of decomposing under natural conditions.
        <br />
        <br />
        <em>Source:</em> United States Environmental Protection Agency.{" "}
        <a
          href="http://www.epa.sa.gov.au/files/4771336_guide_waste_definitions.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Biodiversity",
    definition: (
      <>
        The variability among living organisms from all sources including, inter
        alia, terrestrial, marine and other aquatic ecosystems and the
        ecological complexes of which they are part; this includes diversity
        within species, between species and of ecosystems.
        <br />
        <br />
        <em>Source:</em> Convention on Biological Diversity. “Article 2. Use of
        Terms.” 1992.{" "}
        <a
          href="https://www.cbd.int/convention/articles/default.shtml?a=cbd-02"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Biomimicry",
    definition: (
      <>
        Biomimicry is a practice that learns from and mimics the strategies
        found in nature to solve human design challenges.
        <br />
        <br />
        <em>Source:</em> The Biomimicry Institute.{" "}
        <a
          href="https://biomimicry.org/what-is-biomimicry/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "BIPOC",
    definition: <>Black, Indigenous, and People of Color</>,
  },
  {
    term: "Blackwater",
    definition: (
      <>
        Wastewater from toilets.
        <br />
        <br />
        <em>Source:</em> Zehnder, Alexander J. B., Hong Yang, and Roland
        Schertenlieb. “Water Issues: The Need for Action at Different Levels.”
        Aquatic Sciences 65, no. 1 (March 2003): 1–20.{" "}
        <a
          href="https://doi.org/10.1007/s000270300000"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Board of Directors",
    definition: (
      <>
        A group of people legally responsible to govern an organization and
        responsible to the shareholders and other relevant stakeholders. A
        governing body with a different name (e.g., "advisory body") may be
        considered a Board of Directors provided it has a fiduciary
        responsibility to shareholders and/or other relevant stakeholders.
      </>
    ),
  },
  {
    term: "Building Reuse",
    definition: (
      <>
        Renovation/remodeling of old buildings. Some guidelines specify that to
        be considered building reuse, the building(s) must have been initially
        constructed (and completed) at least 40 years ago. The purpose of
        building reuse can vary, such as saving natural resources (including raw
        material, energy, and water required to build new buildings), preventing
        pollution (byproducts of extraction, manufacturing and transportation of
        virgin materials), avoiding solid waste creation, etc.
        <br />
        <br />
        <em>Source:</em> Adapted from Triple Bottom Line Collaborative{" "}
        <a
          href="http://www.craft3.org/docs/case-studies/opportunity-finance-network-tbl-innovations-report-050108.pdf?sfvrsn=0"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        and the National Trust for Historic Preservation{" "}
        <a
          href="http://www.preservationnation.org/information-center/sustainable-communities/green-lab/lca/The_Greenest_Building_lowres.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Business to Business (B2B)",
    definition: (
      <>
        Organization operates by selling its goods or services to other
        businesses, formally or informally.
      </>
    ),
  },
  {
    term: "Business to Consumer (B2C)",
    definition: (
      <>
        Organization operates by selling its goods or services to the end
        consumer (individuals, households, communities, etc.).
      </>
    ),
  },
  {
    term: "Business to Government (B2G)",
    definition: (
      <>
        Organization operates by selling/providing its goods or services to
        government agencies.
      </>
    ),
  },
  {
    term: "Carbon Capture and Storage (CCS)",
    definition: (
      <>
        Carbon Capture and Storage (CCS) is a technology that can capture up to
        90% of the carbon dioxide (CO₂) emissions produced from the use of
        fossil fuels in electricity generation and industrial processes,
        preventing the carbon dioxide from entering the atmosphere.
        <br />
        <br />
        <em>Source:</em> “What Is CCS?” Carbon Capture and Storage Association
        (CCSA).{" "}
        <a
          href="http://www.ccsassociation.org/what-is-ccs/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Carbon Credits",
    definition: (
      <>
        A carbon credit, or a carbon offset, is a financial unit of measurement
        that represents the removal of one metric ton of carbon dioxide
        equivalent (tCO₂e) from the atmosphere. Carbon credits, also known as
        Certified Emission Reductions (CERs), enable businesses to compensate
        for their emissions, meet their carbon reduction goals, and support the
        move to a low carbon economy. Carbon offsetting markets were created as
        a mechanism to achieve the targets set within the Kyoto Protocol,
        adopted by the United Nations Framework Convention on Climate Change
        (UNFCCC).
        <br />
        <br />
        Carbon offsetting delivers financing to essential renewable energy,
        forestry, and resource conservation projects which generate reductions
        in Greenhouse Gases (GHG) emissions. Projects can be validated and
        verified to demonstrate that they are generating GHG reductions and can
        be monitored on a regular basis through independent third parties.
        <br />
        <br />
        Organizations can refer to the following resources for additional
        guidance on carbon offsets:
        <br />- United Nations Framework Convention on Climate Change{" "}
        <a
          href="http://unfccc.int/kyoto_protocol/items/2830.php"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Carbon Neutral{" "}
        <a
          href="http://www.carbonneutral.com/resource-hub/carbon-offsetting-explained"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Natural Resources Defense Council{" "}
        <a
          href="http://www.nrdc.org/globalwarming/offsets.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Carbon Dioxide (CO₂)",
    definition: (
      <>
        A relatively heavy, colorless gas formed primarily through animal
        respiration and the decay and combustion of animal and vegetable matter.
        Carbon dioxide is the primary greenhouse gas emitted as a result of
        human activities.
        <br />
        <br />
        <em>Sources:</em> Merriam-Webster, s.v. “Carbon Dioxide,” accessed March
        2019. Griscom, Bronson W., et al. “Natural Climate Solutions.”
        Proceedings of the National Academy of Sciences 114, no. 44 (October 31,
        2017): 11645–650.
      </>
    ),
  },
  {
    term: "Carbon Dioxide Equivalent",
    definition: (
      <>
        A measure used to compare the emissions from various greenhouse gases
        based upon their global warming potential. For example, the global
        warming potential for methane over 100 years is 21. This means that
        emissions of one million metric tons of methane is equivalent to
        emissions of 21 million metric tons of carbon dioxide.
        <br />
        <br />
        <em>Source:</em> OECD (Organisation for Economic Co-operation and
        Development). Glossary of Statistical Terms. s.v. “Carbon dioxide
        equivalent,” accessed May 2019.{" "}
        <a
          href="https://stats.oecd.org/glossary/detail.asp?ID=285"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Carbon Neutral",
    definition: (
      <>
        Making no net release of carbon dioxide to the atmosphere, especially
        through offsetting emissions by planting trees.
        <br />
        <br />
        <em>Source:</em> Levin, Kelly, Jiawei Song, and Jennifer Morgan. “COP21
        Glossary of Terms Guiding the Long-Term Emissions-Reduction Goal.” World
        Resources Institute, December 2015.{" "}
        <a
          href="https://www.wri.org/blog/2015/12/cop21-glossary-terms-guiding-long-term-emissions-reduction-goal"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Carbon Sequestration",
    definition: (
      <>
        The direct removal of carbon dioxide from the atmosphere.
        <br />
        <br />
        <em>Source:</em> Minx, Jan C., et al. “Negative Emissions—Part 1:
        Research Landscape and Synthesis.” Environmental Research Letters 13,
        no. 6 (May 22, 2018): 063001.
      </>
    ),
  },
  {
    term: "Caregiver Professionals",
    definition: (
      <>
        Caregiver health professionals -- a subgroup of caregivers -- provide
        preventive, curative, rehabilitative, and promotional health services
        based on an extensive body of theoretical and factual knowledge in
        diagnosis and treatment of disease and other health problems. They may
        conduct research on human disorders/illnesses and ways of treating them,
        as well as supervise other workers.
        <br />
        <br />
        Caregiver professionals are distinct from the larger group of caregivers
        in that their knowledge and skills are the result of study at a higher
        educational institution in a health-related field for a period of 3-6
        years leading to the award of a first degree or higher qualification.
        This includes general and specialist medical practitioners, nurses,
        dentists, paramedics, etc.
        <br />
        <br />
        <em>Sources:</em> Adapted from the World Health Organization{" "}
        <a
          href="http://www.who.int/hrh/statistics/Health_workers_classification.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        and the International Labor Office's International Standard
        Classification of Occupations{" "}
        <a
          href="http://www.ilo.org/wcmsp5/groups/public/---dgreports/---dcomm/---publ/documents/publication/wcms_172572.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Caregivers",
    definition: (
      <>
        Individuals who provide preventative, curative, rehabilitative, and
        promotional health services. A caregiver could be a doctor, nurse,
        clinician, community health worker, etc.
      </>
    ),
  },
  {
    term: "Cash Equivalents",
    definition: (
      <>
        Cash equivalents are short-term, highly-liquid investments that are
        readily convertible to known amounts of cash and are not subject to
        significant risk of changes in value.
        <br />
        <br />
        <em>Source:</em> International Financial Reporting Standards{" "}
        <a
          href="http://ifrs.wiley.com/glossary/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Catastrophic Health Expenditure",
    definition: (
      <>
        Catastrophic health expenditure is defined as out-of-pocket spending for
        health care that exceeds a certain proportion of a household’s income
        with the consequence that households suffer the burden of disease and
        may be pushed into poverty as a result. Examples: unexpected injuries,
        serious illnesses, etc.
        <br />
        <br />
        <em>Source:</em> World Health Organization{" "}
        <a
          href="https://www.who.int/bulletin/volumes/90/9/12-102178/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Catchment",
    definition: (
      <>
        The geographical zone in which water is captured, flows through and
        eventually discharges at one or more points. The concept includes both
        surface water catchment and groundwater catchment. A surface water
        catchment is defined by the area of land from which all precipitation
        received flows through a sequence of streams and rivers towards a single
        river mouth, as tributary to a larger river, or to the sea. A
        groundwater catchment is defined by a geological structure of an aquifer
        and groundwater flow paths. It is replenished by water that infiltrates
        from the surface. Depending on local conditions, surface and groundwater
        catchments may be physically separate or interconnected.
        <br />
        <br />
        <em>Source:</em> Ramsar Convention on Wetlands. Global Wetland Outlook:
        State of the World’s Wetlands and their Services to People. Gland,
        Switzerland: Ramsar Convention Secretariat, 2018.
      </>
    ),
  },
  {
    term: "Certification",
    definition: (
      <>
        A certification must be from a third party, be standards-based, have
        those standards be transparent, and have an assurance process. The
        process of certification is carried out by a recognized body,
        independent from interested parties, which demonstrates that a product
        or organization complies with the requirements defined in the standards
        or technical specifications.
      </>
    ),
  },
  {
    term: "Certified",
    definition: (
      <>
        Receiving certification from a recognized body that is independent from
        interested parties and can demonstrate that the organization complies
        with the requirements defined in the standards or technical
        specifications.
      </>
    ),
  },
  {
    term: "Children and Adolescents",
    definition: (
      <>
        Persons under the age of 19, as defined by the World Health Organization
        (WHO). For specific details, the WHO defines infants as birth to 1 year,
        children as 1 to 10 years, and adolescents as 10 to 19 years.
        <br />
        <br />
        <em>Source:</em> World Health Organization{" "}
        <a
          href="http://www.who.int/hiv/pub/guidelines/arv2013/intro/keyterms/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Clean Energy Curtailment",
    definition: (
      <>
        Curtailment is the reduction of output of a renewable resource below
        what it could have otherwise produced.
        <br />
        <br />
        <em>Source:</em> "Impacts of renewable energy on grid operations."
        California ISO.{" "}
        <a
          href="https://www.caiso.com/documents/curtailmentfastfacts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Client",
    definition: (
      <>
        Buyer or recipient of the organization's products or services. For the
        impact theme Access to Quality Healthcare, “client” is analogous to
        “patient,” and for the impact theme Affordable Housing, “client” is
        analogous to “resident” or “tenant.”
      </>
    ),
  },
  {
    term: "Client Protection",
    definition: (
      <>
        Client protection can be a relevant concept in a number of sectors.
        Specifically for the microfinance sector, the definition is linked to
        The Campaign for Client Protection in Microfinance, which seeks to unite
        microfinance providers worldwide to develop and implement standards for
        the appropriate treatment of low-income clients based on the following
        seven principles:
        <br />
        1) Appropriate Product Design and Delivery
        <br />
        2) Prevention of Over-Indebtedness
        <br />
        3) Transparency
        <br />
        4) Responsible Pricing
        <br />
        5) Fair and Respectful Treatment of Clients
        <br />
        6) Privacy of Client Data
        <br />
        7) Mechanisms for Complaint Resolution
        <br />
        <br />
        Organizations can refer to the following source for further information
        about the client protection initiative:{" "}
        <a
          href="http://www.smartcampaign.org/about-the-campaign/smart-microfinance-and-the-client-protection-principles"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Climate Adaptation",
    definition: (
      <>
        The process of adjustment to actual or expected climate and its effects.
        In human systems, adaptation seeks to moderate or avoid harm or exploit
        beneficial opportunities. In some natural systems, human intervention
        may facilitate adjustment to expected climate and its effects.
        <br />
        <br />
        <em>Source:</em> Core Writing Team, Rajendra K. Pachuari, and Leo Meyer,
        eds. Climate Change 2014: Synthesis Report. Geneva: Intergovernmental
        Panel on Climate Change, 2014.
      </>
    ),
  },
  {
    term: "Climate Information System",
    definition: (
      <>
        An integrated system that collects, processes, analyzes, and
        disseminates climate data, information, and knowledge to support
        decision-making at all levels.
        <br />
        <br />
        <em>Source:</em>{" "}
        <a
          href="https://wmo.int/activities/climate-services-information-system"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Climate Vulnerability",
    definition: (
      <>
        The degree to which a system (such as a natural, built, or human
        systems) is susceptible to, and unable to cope with, the adverse impacts
        of climate change.
        <br />
        Climate vulnerability is a function of Exposure, Sensitivity and
        Adaptive Capacity.
        <br />
        <br />
        <em>Source:</em> United Nations Framework Convention on Climate Change.{" "}
        <a
          href="https://unfccc.int/files/cooperation_support/least_developed_countries_portal/ldc_expert_group/application/pdf/training_workshop_on_implementing_napa_training_materials_eng.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Climate-Smart Agriculture",
    definition: (
      <>
        An approach that helps guide actions to transform agri-food systems
        towards green and climate resilient practices. CSA supports reaching
        internationally agreed goals such as the SDGs and the Paris Agreement.
        It aims to tackle three main objectives: sustainably increasing
        agricultural productivity and incomes; adapting and building resilience
        to climate change; and reducing and/or removing greenhouse gas
        emissions, where possible.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United
        Nations.{" "}
        <a
          href="https://www.fao.org/climate-smart-agriculture/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Code of Ethics",
    definition: (
      <>
        Sometimes called a Code of Conduct or Code of Business Standards. This
        is a formal document that establishes behavioral expectations for the
        organization and the people who work there.
      </>
    ),
  },
  {
    term: "Collaborative Regimes",
    definition: (
      <>
        Collaborative forestry practiced on land that has some form of communal
        tenure and requires collective action.
        <br />
        <br />
        <em>Source:</em> Gilmour, Don. Forty Years of Community-Based Forestry:
        A Review of Its Extent and Effectiveness. FAO Forestry Paper 176. Rome:
        Food and Agriculture Organization of the United Nations: 2016.
      </>
    ),
  },
  {
    term: "Community",
    definition: (
      <>
        A group of people with diverse characteristics who are linked by social
        ties, share common perspectives, and engage in joint action in
        geographical locations or settings where the investment is taking place.
        <br />
        <br />
        <em>Source:</em> American Journal of Public Health.{" "}
        <a
          href="https://pmc.ncbi.nlm.nih.gov/articles/PMC1446907/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Community Infrastructure",
    definition: (
      <>
        Natural or built physical assets that are accessed by the community, can
        be owned and managed by the public or private sector or the community
        itself. Examples can include, bridges, irrigation pumps, water
        management system, disaster shelters etc.
      </>
    ),
  },
  {
    term: "Community Service Policy",
    definition: (
      <>
        A policy that encourages and allows employees to volunteer or engage in
        charitable giving.
      </>
    ),
  },
  {
    term: "Community-Based Forestry",
    definition: (
      <>
        Community-based forestry includes initiatives, sciences, policies,
        institutions and processes that are intended to increase the role of
        local people in governing and managing forest resources.
        <br />
        <br />
        <em>Source:</em> Gilmour, Don. Forty Years of Community-Based Forestry:
        A Review of Its Extent and Effectiveness. FAO Forestry Paper 176. Rome:
        Food and Agriculture Organization of the United Nations: 2016.
      </>
    ),
  },
  {
    term: "Conflict of Interest",
    definition: (
      <>
        A set of circumstances that creates a risk that professional judgment or
        actions regarding a primary interest will be unduly influenced by a
        secondary interest.
        <br />
        <br />
        <em>Source:</em> Conflict of Interest in Medical Research, Education,
        and Practice, Lo and Field, 2009{" "}
        <a
          href="http://www.ncbi.nlm.nih.gov/books/NBK22942/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Conflict-Sensitive Education",
    definition: (
      <>
        Understanding the context in which the education policy/program takes
        place, analyzing the two-way interaction between the context and the
        education policy/program, and acting to minimize negative impacts and
        maximize positive impacts of education policies and programming on
        conflict, within an organization’s given priorities.
        <br />
        <br />
        <em>Source:</em> Conflict Sensitivity Consortium
      </>
    ),
  },
  {
    term: "Conservation",
    definition: (
      <>
        The management of human use of nature so that it may yield the greatest
        sustainable benefit to current generations while maintaining its
        potential to meet the needs and aspirations of future generations.
      </>
    ),
  },
  {
    term: "Consumptive Use",
    definition: (
      <>
        Water that is not returned to the original source after use.
        <br />
        <br />
        <em>Source:</em> Ongley, Edwin D. “Control of Water Pollution from
        Agriculture.” FAO Irrigation and Drainage Paper No. 55, Rome, 1996.
      </>
    ),
  },
  {
    term: "Container-Based Sanitation",
    definition: (
      <>
        An end-to-end sanitation service in which excreta are collected
        hygienically from toilets designed with sealable, removable containers
        and then safely treated, disposed of, or reused. Rather than allocating
        scarce capital to build a sanitation facility, households (or
        public-toilet operators) can sign up for the service.
        <br />
        <br />
        <em>Source:</em> Stip, Clementine Marie, Seema Thomas, and Martin
        Gambrill. “Container-Based Sanitation: One Way to Reach the Last Mile
        for Sanitation Services.” The Water Blog. World Bank, February 19, 2019.{" "}
        <a
          href="https://blogs.worldbank.org/water/container-based-sanitation-one-way-reach-last-mile-sanitation-services"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Contract",
    definition: (
      <>
        A contract is an agreement with specific terms between two or more
        persons or entities in which there is a promise to do something in
        return for a valuable benefit, such as payment. The existence of a
        contract requires that there be a proposed and accepted offer, a promise
        to perform by one entity as well as a promise to provide a valuable
        benefit by the other (payment), and a time or event by which performance
        must occur.
      </>
    ),
  },
  {
    term: "Contributing Family Workers",
    definition: (
      <>
        Those workers who hold “self-employment jobs” as own-account workers in
        a market-oriented establishment operated by a related person living in
        the same household.
        <br />
        <br />
        <em>Source:</em> Resolution Concerning the International Classification
        of Employment (ICSE), ILO, Fifteenth International Conference of Labour
        Statisticians, 1993.{" "}
        <a
          href="http://www.ilo.ch/wcmsp5/groups/public/---dgreports/---stat/documents/normativeinstrument/wcms_087562.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Conventional Agriculture",
    definition: (
      <>
        The management of human use of nature so that it may yield the greatest
        sustainable benefit to current generations while maintaining its
        potential to meet the needs and aspirations of future generations.
        <br />
        <br />
        <em>Source:</em> OpenStax, Kamala Doršner, Alexandra Geddes, Tom Theis,
        Jonathan Tomkin, and Matthew R. Fisher. “9.3 Conventional Agriculture.”
        Environmental Biology. Open Oregon Educational Resources.{" "}
        <a
          href="https://openoregon.pressbooks.pub/envirobiology/chapter/9-3-conventional-agriculture/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Cooperative (Co-op)",
    definition: (
      <>
        An autonomous association of persons united voluntarily to meet their
        common economic, social, and cultural needs and aspirations through a
        jointly-owned and democratically-controlled enterprise.
        <br />
        <br />
        <em>Source:</em> International Labor Organization{" "}
        <a
          href="http://www.ilo.org/thesaurus/defaulten.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        (and search for "cooperative")
      </>
    ),
  },
  {
    term: "Core Metrics Set",
    definition: (
      <>
        IRIS+ core metrics sets are the evidence and best-practice-based sets of
        IRIS metrics used to assess the effects of any investment or enterprise
        across the five dimensions of impact.
      </>
    ),
  },
  {
    term: "Corporate Governance",
    definition: (
      <>
        Corporate governance is the system by which business corporations are
        directed and controlled. The corporate governance structure specifies
        the distribution of rights and responsibilities among different
        participants in the corporation (such as the boards, managers,
        shareholders, and other stakeholders) and spells out the rules and
        procedures for making decisions on corporate affairs. By doing this, it
        also provides the structure through which the company objectives are
        set, as well as a means of attaining those objectives and monitoring
        performance.
        <br />
        <br />
        <em>Source:</em> Organization for Economic Co-operation and Development{" "}
        <a
          href="http://link.springer.com/chapter/10.1007/978-4-431-30920-8_10#page-1"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Corporation",
    definition: (
      <>
        An organization where shareholders maintain ownership and which is
        managed by a Board.
      </>
    ),
  },
  {
    term: "Critical Equipment",
    definition: (
      <>
        Critical equipment or facilities are those fixed assets necessary for
        the organization to provide its products and services in the sense that
        they are materially necessary. Materially necessary means that if the
        equipment were destroyed, degraded, or compromised, it would make it
        difficult or impossible for the organization to provide its
        services/products. It is also typically equipment that has a maximum
        utilization that is a limiting factor on the units produced or services
        provided. For example, a hospital might cite patient beds, an MRI
        machine, or sterile surgical rooms as critical equipment/facilities.
      </>
    ),
  },
  {
    term: "Cropland",
    definition: (
      <>
        Cropland is a land cover class that includes all cultivated herbaceous
        crops, woody crops and multiple and layered crops.
        <br />
        <br />
        <em>Source:</em> “The Status of the World's Soil Resources.” Food and
        Agriculture Organization of the United Nations (FAO) and
        Intergovernmental Technical Panel (ITPS), 2015.{" "}
        <a
          href="https://www.researchgate.net/publication/285597377_The_Status_of_the_World's_Soil_Resources"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Cultural Values/Services",
    definition: (
      <>
        Cultural Values/Services are the nonmaterial benefits obtained from
        ecosystems.
        <br />- Recreation and ecotourism: Recreational pleasure people derive
        from natural or cultivated ecosystems
        <br />- Ethical and spiritual values: Spiritual, religious, aesthetic,
        intrinsic, "existence,” or similar values people attach to ecosystems,
        landscapes, or species
        <br />- Educational and inspirational values: Information derived from
        ecosystems used for intellectual development, culture, art, design, and
        innovation
        <br />
        <br />
        <em>Source:</em> WRI{" "}
        <a
          href="http://pdf.wri.org/esr_definitions_of_ecosystem_services.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Deforestation",
    definition: (
      <>
        The destruction of forests in order to make the land available for
        other, non-forest uses. Organizations can refer to the following sources
        for further information on deforestation:
        <br />- Intergovernmental Panel on Climate Change{" "}
        <a
          href="http://www.ipcc.ch/ipccreports/sres/land_use/index.php?idp=295"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Food and Agriculture Organization of the United Nations{" "}
        <a
          href="http://www.fao.org/forestry/30515/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Degradation",
    definition: (
      <>
        “Changes within the forest which negatively affect the structure or
        function of the stand or site, and thereby lower the capacity to supply
        products and/or services.”
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United Nations
        (FAO). “Forest Degradation.” 2006.{" "}
        <a
          href="http://www.fao.org/3/j9345e/j9345e08.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Depreciation and Amortization",
    definition: (
      <>
        Depreciation and Amortization is the systematic allocation of
        depreciable assets, tangible (depreciation) and intangible
        (amortization), over the assets' useful lives.
        <br />
        <br />
        <em>Source:</em> Adapted from International Financial Reporting
        Standards{" "}
        <a
          href="http://ifrs.wiley.com/glossary/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Direct Air Capture",
    definition: (
      <>
        Direct air capture is a process of capturing carbon dioxide directly
        from the ambient air and generating a concentrated stream of CO₂ for
        sequestration or utilization.
        <br />
        <br />
        <em>Source:</em> “Direct Air Capture (Technology Factsheet).”
        Geoengineering Monitor, May 2018.{" "}
        <a
          href="http://www.geoengineeringmonitor.org/2018/05/direct-air-capture/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Direct Emissions",
    definition: (
      <>
        Emissions of greenhouse gases that are from sources that are owned or
        controlled by the reporting organization.
        <br />
        <br />
        <em>Source:</em> GHG Protocol{" "}
        <a
          href="http://www.ghgprotocol.org/calculation-tools/faq"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Directly Controlled (land area)",
    definition: (
      <>
        Land area under the organization's direct control is land for which the
        organization completely controls land use through direct operation or
        management. This includes situations where the organization's employees
        cultivate the land directly.
        <br />
        <br />
        Note that land ownership is not always equivalent to control. For
        example, in situations where land is leased to another entity or
        individual to cultivate, land is only directly controlled if the lease
        is accompanied by exhaustive land use criteria. If this land use
        criteria still allows the organization to have financial control and
        management over the land, the land is still considered to be directly
        controlled by the organization.
      </>
    ),
  },
  {
    term: "Disabilities",
    definition: (
      <>
        A person with a disability is defined as someone who has, or considers
        themselves to have, a long-term or recurring issue that impacts one or
        more activities that others may consider to be a daily function. This
        definition also includes the perception among others that a disability
        exists.
        <br />
        <br />
        <em>Source:</em> Lime Connect{" "}
        <a
          href="http://www.limeconnect.com/about/page/how-we-define-disability"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Disability-Adjusted Life Year (DALY)",
    definition: (
      <>
        A measure of overall disease burden, expressed as the number of years
        lost due to ill-health, disability or early death. It was developed in
        the 1990s as a way of comparing the overall health and life expectancy
        of different countries.
        <br />
        <br />
        <em>Source:</em> World Health Organization{" "}
        <a
          href="https://www.who.int/healthinfo/global_burden_disease/metrics_daly/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Discrimination",
    definition: (
      <>
        The unequal treatment of members of various groups based on race,
        gender, social class, sexual orientation, physical ability, religion and
        other categories.
        <br />
        <br />
        <em>Source:</em> “Racial Equity Tools - Glossary.” Racial Equity Tools,
        n.d.{" "}
        <a
          href="http://archive.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Disguised Employment / Dependent Self-Employment",
    definition: (
      <>
        A situation where an employer wrongfully treats a worker as an
        independent contractor and hides their true status as a wage employee.
        <br />
        <br />
        <em>Source:</em> "Non-Standard Employment Around the World:
        Understanding Challenges, Shaping Prospects." ILO, 2016{" "}
        <a
          href="https://www.ilo.org/global/publications/books/WCMS_534496/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Distributed Energy Storage",
    definition: (
      <>
        The ability to retain small or large amounts of energy produced where
        you live or work and use it to meet your own needs.
        <br />
        <br />
        <em>Source:</em> Distributed Energy Storage, Drawdown.{" "}
        <a
          href="https://drawdown.org/solutions/distributed-energy-storage"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Distributed Plantations",
    definition: (
      <>
        Companies that aggregate supply through trees grown by smallholder
        farmers on the farmers’ land.
        <br />
        <br />
        <em>Source:</em> Faruqi, Sofia, Andrew Wu, Eriks Brolis, Andrés Anchondo
        Ortega, and Alan Batista. The Business of Planting Trees: A Growing
        Investment Opportunity. Washington, DC: World Resources Institute, 2018.
      </>
    ),
  },
  {
    term: "Distributors",
    definition: (
      <>
        An individual or organization that sells products or services to other
        distributors (wholesale) or to the ultimate consumer (retail).
      </>
    ),
  },
  {
    term: "Diversity",
    definition: (
      <>
        Diversity includes all the ways in which people differ, and it
        encompasses all the different characteristics that make one individual
        or group different from another. It is all-inclusive and recognizes
        everyone and every group as part of the diversity that should be valued.
        A broad definition includes not only race, ethnicity, and gender — the
        groups that most often come to mind when the term "diversity" is used —
        but also age, national origin, religion, disability, sexual orientation,
        socioeconomic status, education, marital status, language, and physical
        appearance. It also involves different ideas, perspectives, and values.
        <br />
        <br />
        <em>Source:</em> “Racial Equity Tools - Glossary.” Racial Equity Tools,
        n.d.{" "}
        <a
          href="http://archive.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Donation (Charitable)",
    definition: (
      <>
        Charitable donations include financial contributions and in-kind
        donations of goods and services to charities, private foundations,
        non-profit organizations, or non-governmental organizations. Pricing
        discounts do not count as charitable donations; only free services are
        considered to be in-kind donations.
      </>
    ),
  },
  {
    term: "Dropout Student",
    definition: (
      <>
        A student who, for any reason other than death, leaves school before
        graduation without transferring to another school/institution.
        <br />
        <br />
        <em>Source:</em> Pennsylvania Government Department of Education{" "}
        <a
          href="https://www.education.pa.gov/DataAndReporting/Dropouts/Pages/default.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        For more information, see: UNESC-UNEVOC{" "}
        <a
          href="https://unevoc.unesco.org/go.php?q=TVETipedia+Glossary+A-Z&id=155"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Early Warning System",
    definition: (
      <>
        Early warning system is an adaptive measure for climate change, using
        integrated communication systems to help communities prepare for
        hazardous climate-related events.
        <br />
        <br />
        <em>Source:</em> United Nations.{" "}
        <a
          href="https://www.un.org/en/climatechange/climate-solutions/early-warning-systems"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Earned Premium",
    definition: (
      <>
        The value of the portion of a policy's premium that applies to the
        expired portion of the policy. Although insurance premiums are often
        paid in advance, insurers typically earn the premium at an even rate
        throughout the policy term. The remainder is the unearned premium.
        <br />
        <br />
        <em>Source:</em> International Risk Management Institute{" "}
        <a
          href="http://www.irmi.com/online/insurance-glossary/terms/e/earned-premium.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ecological Restoration",
    definition: (
      <>
        Ecological restoration is the process of assisting the recovery of an
        ecosystem that has been degraded, damaged, or destroyed. An ecosystem
        has recovered - and is restored - when it contains sufficient biotic and
        abiotic resources to continue its development without further assistance
        or subsidy. It will sustain itself structurally and functionally. It
        will demonstrate resilience to normal ranges of environmental stress and
        disturbance. It will interact with contiguous ecosystems in terms of
        biotic and abiotic flows and cultural interactions.
        <br />
        <br />
        For example, if the objective is to establish tree cover with a
        designated species composition and species abundance on former cropland,
        one intervention could be to plant sapling trees of the designated
        species at specified densities. Refer to Society for Ecological
        Restoration Guidelines for Developing and Managing Ecological
        Restoration Projects for additional background information.
        <br />
        <br />
        <em>Source:</em> Society for Ecological Restoration{" "}
        <a
          href="http://www.ser.org/resources/resources-detail-view/ser-international-primer-on-ecological-restoration#3"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ecosystem",
    definition: (
      <>
        A dynamic complex of organisms and their associated non-living
        environment, interacting as an ecological unit composed of primary
        producers, consumers, and decomposers.
        <br />
        <br />
        <em>Source:</em> Falkenmark, Malin. “Water Management and Ecosystems:
        Living with Change.” Technical Committee (TEC) Background Paper No. 9,
        Stockholm, Sweden, Global Water Partnership, 2003.{" "}
        <a
          href="https://www.gwp.org/globalassets/global/toolbox/publications/background-papers/09-water-management-and-eco-systems.-living-with-change-2003-english.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ecosystem Health",
    definition: (
      <>
        A dynamic balance between plants, animals, and the surrounding
        environment comprises an ecosystem. The impact of humans, as an integral
        part of most ecosystems, must be taken into account when managing the
        system’s health. For healthy functioning and sustainability, an
        ecosystem’s living members must be in balance with the non-living
        elements.
        <br />
        <br />
        <em>Source:</em> “National Institute of Food and Agriculture.”
        Ecosystems | National Institute of Food and Agriculture, n.d.{" "}
        <a
          href="https://nifa.usda.gov/topic/ecosystems"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ecosystem Services",
    definition: (
      <>
        The benefits people obtain from ecosystems. These include provisioning
        services such as food and water; regulating services such as regulation
        of floods, drought, land degradation, and disease; supporting services
        such as soil formation and nutrient cycling; and cultural services such
        as recreational, spiritual, religious, and other non-material benefits.
        <br />
        <br />
        Provisioning services are goods provided by ecosystems and include
        crops, timber, and livestock as well as genetic resources for medicines.
        Regulating services maintain healthy ecosystem functioning and include
        water purification, pollination, water regulation, and climate
        regulation. Cultural services are intangible and non-material value
        people derive from nature and include spiritual and aesthetic benefits
        as well as recreation and tourism. Supporting services are the natural
        processes that maintain the three other ecosystem services.
        <br />
        <br />
        Organizations can refer to the following sources for additional
        information on ecosystem services:
        <br />- United Nations Environment Programme{" "}
        <a
          href="http://www.unep.org/maweb/documents/document.766.aspx.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Millenium Ecosystem Assessment{" "}
        <a
          href="http://www.millenniumassessment.org/documents/document.356.aspx.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Education Management Information System (EMIS)",
    definition: (
      <>
        An Education Management Information System (EMIS) collects, monitors,
        manages, analyzes, and disseminates information about education inputs,
        processes, and outcomes, especially student learning.
        <br />
        <br />
        <em>Source:</em> Abdul-Hamid, Husein. Data for Learning: Building a
        Smart Education Data System. Washington, DC: World Bank, 2017.
      </>
    ),
  },
  {
    term: "E-Flows",
    definition: (
      <>
        The quantity, quality, and timing of water flows required to sustain the
        ecological health of a water body.
        <br />
        <br />
        <em>Source:</em> OECD. Water Resources Allocation: Sharing Risks and
        Opportunities. OECD Studies on Water. Paris: OECD Publishing, 2015.{" "}
        <a
          href="https://doi.org/10.1787/9789264229631-en"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Emissions Reductions",
    definition: (
      <>
        Emissions reductions occur when greenhouse gas emissions intensive
        processes are replaced with processes that are less greenhouse gas
        intensive.
        <br />
        <br />
        <em>Source:</em> Environmental and Energy Study Institute:{" "}
        <a
          href="https://www.eesi.org/articles/view/u.s.-leads-in-greenhouse-gas-reductions-but-some-states-are-falling-behind"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Employee Tenure",
    definition: (
      <>
        Employee tenure is a measure of how long salaried and non-salaried
        workers have been with their current employer at the time of
        measurement.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Department of Labor,
        Bureau of Labor Statistics{" "}
        <a
          href="http://www.bls.gov/news.release/tenure.nr0.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Endangered or Vulnerable Species",
    definition: (
      <>
        All species with the status of "Near Threatened," "Vulnerable,"
        "Endangered," or "Critically Endangered" on the Red List of Threatened
        Species prepared by the International Union for the Conservation of
        Nature (IUCN).
        <br />
        <br />
        <em>Source:</em> IUCN{" "}
        <a
          href="http://www.iucnredlist.org"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Energy Conservation",
    definition: (
      <>
        Energy conservation refers to efforts made to reduce the total amount of
        energy needed to carry out current processes or tasks. The term does not
        include overall reduction in energy consumption from reduced
        organizational activities (e.g., partial outsourcing of production).
        <br />
        <br />
        <em>Source:</em> Global Reporting Initiative{" "}
        <a
          href="https://www.globalreporting.org/standards/G3andG3-1/guidelines-online/G3Online/StandardDisclosures/Environmental/Pages/EN12IndicatorProtocol.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Environmental Management System",
    definition: (
      <>
        An Environmental Management System (EMS) is a set of processes and
        practices that enable an organization to reduce its environmental
        impacts and increase its operating efficiency. An EMS helps a company
        address its regulatory demands in a systematic and cost-effective
        manner. It can also help address non-regulated issues such as energy
        conservation and can promote stronger operational control and employee
        stewardship.
        <br />
        <br />
        <em>Source:</em> Adapted from the EPA{" "}
        <a
          href="http://www.epa.gov/ems/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Erosion",
    definition: (
      <>
        Erosion or soil erosion is broadly defined as the removal of (top-) soil
        from the land surface by running water, wind, ice or gravity. It can be
        accelerated by human activities (tillage) and animals.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ethnicity",
    definition: (
      <>
        Ethnicity is a social construct that divides people into smaller social
        groups based on characteristics such as shared sense of group
        membership, values, behavioral patterns, language, political and
        economic interests, history, and ancestral geographical base.
        <br />
        <br />
        Examples of different ethnic groups are: Cape Verdean, Haitian, African
        American (Black); Chinese, Korean, Vietnamese (Asian); Cherokee, Mohawk,
        Navaho (Native American); Cuban, Mexican, Puerto Rican (Latino); Polish,
        Irish, and Swedish (White).
        <br />
        <br />
        <em>SOURCE:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing Teaching for Diversity and Social Justice: A Sourcebook, edited
        by Maurianne Adams, Lee Anne Bell, and Pat Griffin, Routledge, 1997.
      </>
    ),
  },
  {
    term: "Exposure",
    definition: (
      <>
        The extent to which a system is exposed to climate hazards such as
        extreme weather events (e.g., hurricanes, floods, droughts), sea-level
        rise, and temperature extremes.
        <br />
        <br />
        <em>Source:</em> Intergovernmental Panel on Climate Change and US
        Climate Resilience Toolkit.{" "}
        <a
          href="https://www.ipcc.ch/sr15/chapter/glossary/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Fair Dismissal",
    definition: (
      <>
        Reasons for dismissal which shall not be considered valid include those
        based on union membership or participation in union activities, filing
        of a complaint against an employer, race, color, sex, marital status,
        family responsibilities, pregnancy, religion, political opinion,
        national extraction or social origin, temporary absence due to illness,
        or absence from work during maternity leave.
        <br />
        <br />
        <em>Source:</em> International Labor Organization{" "}
        <a
          href="http://www.ilo.org/public/libdoc/ilo/1982/82B09_147_engl.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Fast Fashion",
    definition: (
      <>
        Inexpensive clothing produced rapidly by mass-market retailers in
        response to the latest trends.
        <br />
        <br />
        <em>Source:</em> Hayes, Adam. “How Fast Fashion Works.” Investopedia.
        Investopedia, April 2020.{" "}
        <a
          href="https://www.investopedia.com/terms/f/fast-fashion.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Fecal Sludge Management (FSM)",
    definition: (
      <>
        The collection, treatment, and disposal or reuse of fecal waste captured
        on-site in containers, latrines, or septic tanks.
        <br />
        <br />
        <em>Source:</em> Centre for Science and Environment. “Decentralised
        Waste Water Treatment Case Studies: Faecal Sludge (Septage) Management.”{" "}
        <a
          href="https://www.cseindia.org/faecal-sludge-septage-management-6213"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Feedback System (Publicly-known)",
    definition: (
      <>
        A publicly-known feedback system that clients or employees can use to
        provide feedback, ask questions, and file complaints that is broadly
        recognized and promoted by the company and that most/all
        clients/employees are aware of. A publicly-known system does not include
        a company that accepts feedback through informal systems (such as
        occasional phone calls from customers or reliance on self-volunteerism
        from employees).
      </>
    ),
  },
  {
    term: "Feed-In Tariff (Fit)",
    definition: (
      <>
        A feed-in tariff is a policy tool designed to promote investment in
        renewable energy sources. This usually means promising small-scale
        producers of the energy—such as solar or wind energy—an above-market
        price for what they deliver to the grid.
        <br />
        <br />
        <em>Source:</em> Kenton, Will. “Feed-In Tariff (FIT).” Investopedia.
        Investopedia, May 2020.{" "}
        <a
          href="https://www.investopedia.com/terms/f/feed-in-tariff.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Financial Inclusion",
    definition: (
      <>
        Financial inclusion means that formal financial services are readily
        available to consumers and that they are actively and effectively using
        these services to meet their specific needs.
        <br />
        <br />
        <em>Source:</em> Social Performance Task Force{" "}
        <a
          href="https://sptf.info/images/The-role-of-the-SPTF-in-achieving-the-UNs-Sustainable-Development-Goals-Sept2016.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Financial Services Delivery Methodology",
    definition: (
      <>
        1. Individual loans: A loan made to an individual borrower who is solely
        responsible for its repayment. While a guarantor or physical collateral
        may exist, the individual bears the primary responsibility for the loan.
        <br />
        2. Solidarity group: A loan group made up of approximately 3-10 people
        drawn from the same community and where group members collectively
        guarantee loan repayment; social collateral oftentimes replaces physical
        collateral.
        <br />
        3. Village banking: As in solidarity groups, loan repayment is
        guaranteed by collective membership, but loan groups are bigger and made
        up of approximately 20-30 people (typically women).
        <br />
        4. Digital financial services
        <br />
        5. Agency banking
        <br />
        6. Licensed agents working on behalf of the FSP
        <br />
        7. Roving staff/mobile branches
        <br />
        8. ATMs
        <br />
        9. Mobile banking
        <br />
        10. Internet-based services
        <br />
        11. Merchant POS or a networked merchant
        <br />
        12. Other
        <br />
        <br />
        Organizations can refer to the following sources for additional
        clarification on the definition:
        <br />- Microfinance Information Exchange Social Performance Indicators{" "}
        <a
          href="http://www.truevaluemetrics.org/DBpdfs/EcoMetrics/IRIS/Core%20MIX%20SPTF%20Indicators_0.xlsx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Microfinance Information Exchange Glossary{" "}
        <a
          href="http://www.mixmarket.org/about/faqs/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Financial Shock",
    definition: (
      <>
        An unexpected or unpredictable event, like job loss, illness, injury,
        death, or large-scale unexpected expense.
        <br />
        <br />
        <em>Source:</em> Pew Charitable Trusts{" "}
        <a
          href="https://www.pewtrusts.org/~/media/assets/2015/10/emergency-savings-report-1_artfinal.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Food Security",
    definition: (
      <>
        Food security, as defined by the United Nations’ Committee on World Food
        Security, means that all people, at all times, have physical, social,
        and economic access to sufficient, safe, and nutritious food that meets
        their food preferences and dietary needs for an active and healthy life.
        <br />
        <br />
        <em>Source:</em> “Food Security.” International Food Policy Research
        Institute (IFPRI), n.d.{" "}
        <a
          href="https://www.ifpri.org/topic/food-security"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Forced Labor",
    definition: (
      <>
        All work or service that is exacted from any person under the menace of
        any penalty and for which the said person has not offered himself
        voluntarily, according to the ILO Forced Labour Convention, 1930 (No.
        29).
        <br />
        <br />
        <em>Source:</em> "CO29 - Forced Labour Convention" ILO, 1930.{" "}
        <a
          href="https://www.ilo.org/dyn/normlex/en/f?p=NORMLEXPUB:55:0::NO::P55_TYPE,P55_LANG,P55_DOCUMENT,P55_NODE:CON,en,C029,/Document"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Forced Marriage",
    definition: (
      <>
        Forced marriage refers to situations where persons, regardless of their
        age, have been forced to marry without their consent. A person might be
        forced to marry through physical, emotional, or financial duress,
        deception by family members, the spouse, or others, or the use of force,
        threats, or severe pressure. Forced marriage is prohibited through the
        prohibitions on slavery and slavery-like practices, including servile
        marriage.
        <br />
        <br />
        <em>Source:</em> "Global Estimates of Modern Slavery: Forced Labour and
        Forced Marriage." ILO, 2017.{" "}
        <a
          href="https://www.ilo.org/global/publications/books/WCMS_575479/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Forest Degradation",
    definition: (
      <>
        Changes within the forest which negatively affect the structure or
        function of the stand or site, and thereby lower the capacity to supply
        products and/or services.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United Nations
        (FAO). “Forest Degradation.” 2006.{" "}
        <a
          href="http://www.fao.org/3/j9345e/j9345e08.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Forest Land",
    definition: (
      <>
        Forest lands have a tree-crown areal density (crown closure percentage)
        of 10 percent or more, are stocked with trees capable of producing
        timber or other wood products, and exert an influence on the climate or
        water regime. Lands from which trees have been removed to less than 10
        percent crown closure but which have not been developed for other uses
        also are included; for example, lands on which there are rotation cycles
        of clear cutting and block planting are part of Forest Land. Note: The
        technical definition of "forest land" may vary by country.
        <br />
        <br />
        Lands that meet the requirements for Forest Land and also for an Urban
        or Built-up category should be placed in the latter category. The only
        exceptions in classifying forest land are those areas which would
        otherwise be classified as Wetland if not for the forest cover. Since
        the wet condition is of much interest to land managers and planning
        groups and is so important as an environmental surrogate and control,
        such lands are classified as Forested Wetland.
        <br />
        <br />
        Forest Land subcategories identified in the Anderson Land Classification
        system include: Deciduous, Evergreen, and Mixed.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Forest Management Plan",
    definition: (
      <>
        A forest management plan is the application of appropriate technical
        forestry principles, practices, and business techniques to the
        management of a forest to achieve the landowner's objectives.
      </>
    ),
  },
  {
    term: "Formalization",
    definition: (
      <>
        While definition of formalization differs by country, most definitions
        require a combination of:
        <br />- Business registration status and licensing with the national,
        provincial, and municipal authorities
        <br />- Access to business infrastructure (e.g. electricity)
        <br />- A written accounting system
        <br />- Compliance with legal framework, including tax, social security,
        and labour laws
        <br />- Access to social security coverage for the business owner and
        his/her employees
        <br />- Membership in professional organizations
        <br />
        <br />
        <em>Sources:</em>
        <br />
        ILO, Enterprise Formalization, EEASE, 2017.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---ed_emp/---emp_ent/---ifp_seed/documents/publication/wcms_544828.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        ILO, Microfinance for decent work, 2015.{" "}
        <a
          href="https://ilo.org/employment/Whatwedo/Publications/employment-reports/WCMS_344847/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Fossil Fuels",
    definition: (
      <>
        Coal, crude oil, and natural gas are all considered fossil fuels because
        they were formed from the fossilized, buried remains of plants and
        animals that lived millions of years ago. Because of their origins,
        fossil fuels have a high carbon content.
        <br />
        <br />
        <em>Source:</em> "Fossil Fuels: The Dirty Facts." NRDC.{" "}
        <a
          href="https://www.nrdc.org/stories/fossil-fuels-dirty-facts"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Fragility",
    definition: (
      <>
        In the context of "fragile state," fragility is defined as a combination
        of exposure to risk and insufficient coping capacity of the state,
        system, or communities to manage, absorb, or mitigate those risks.
        Fragility can lead to violence, breakdown of institutions, displacement,
        humanitarian crises, or other emergencies.
        <br />
        <br />
        <em>Source:</em> Inter-agency Network for Education in Emergencies.
        Conflict Sensitive Education.{" "}
        <a
          href="https://inee.org/collections/conflict-sensitive-education"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Free Trade Agreements (FTA)",
    definition: (
      <>
        A Free Trade Agreement (FTA) is an agreement between two or more
        countries where the countries agree on certain obligations that affect
        trade in goods and services, and protections for investors and
        intellectual property rights, among other topics.
        <br />
        <br />
        <em>Source:</em> “Free Trade Agreement Overview.” International Trade
        Administration | Trade.gov.{" "}
        <a
          href="https://www.trade.gov/free-trade-agreement-overview"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Freedom of Association",
    definition: (
      <>
        Allowing workers to form and join trade unions, worker associations, and
        worker councils or committees of their own choosing.
        <br />
        <br />
        <em>Sources:</em>
        <br />- International Labor Organization's standards on Freedom of
        Association{" "}
        <a
          href="http://www.ilo.org/global/standards/subjects-covered-by-international-labour-standards/freedom-of-association/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Ethical Trading Initiative's ETI Base Code{" "}
        <a
          href="http://www.ethicaltrade.org/eti-base-code"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Freshwater (Bodies)",
    definition: (
      <>
        Non-saline bodies of water located within terrestrial environments and
        unconnected to any tidal or estuarine water bodies. Excludes ephemeral
        bodies of freshwater, which are rain dependent and flow only after
        precipitation.
        <br />
        <br />
        <em>Source:</em> Adapted from the International Union for the
        Conservation of Nature{" "}
        <a
          href="https://cmsdata.iucn.org/downloads/en_iucn__glossary_definitions.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        (search "Fresh water")
      </>
    ),
  },
  {
    term: "Fuel Poverty",
    definition: (
      <>
        When more than approximately 10% of a household’s annual income is spent
        on energy, typically due to low income, high energy costs, and low
        quality housing.
        <br />
        <br />
        <em>Source:</em> "Health and wellbeing – Multiple Benefits of Energy
        Efficiency – Analysis." IEA.{" "}
        <a
          href="https://www.iea.org/reports/multiple-benefits-of-energy-efficiency/health-and-wellbeing"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Full-time Employee",
    definition: (
      <>
        Full-time paid employees work year round and typically work 35-50 hours
        per week. If local definitions of full-time equivalency differ, use the
        appropriate standard.
      </>
    ),
  },
  {
    term: "Full-time Equivalent",
    definition: (
      <>
        A full-time equivalent (FTE) job is the equivalent of one person working
        full time as defined by local laws. FTEs is equal to the number of
        full-time employees plus the number of employees on part-time schedules
        converted to a full-time basis. In most instances this should include
        seasonal, contractual, part-time, and full-time employees hired directly
        by the financed enterprise or through third-party agencies.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Small Business
        Association{" "}
        <a
          href="https://business.usa.gov/sites/default/files/Calculating%20FTEs%20for%20businessUSA.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender",
    definition: (
      <>
        Gender refers to the socially constructed characteristics of women and
        men – such as norms, roles and relationships of and between groups of
        women and men. It varies from society to society and can be changed.
        While most people are born either male or female, they are taught
        appropriate norms and behaviors – including how they should interact
        with others of the same or opposite sex within households, communities
        and work places. When individuals or groups do not “fit” established
        gender norms they often face stigma, discriminatory practices or social
        exclusion – all of which adversely affect health. It is important to be
        sensitive to different identities that do not necessarily fit into
        binary male or female sex categories.
        <br />
        <br />
        <em>Source:</em> World Health Organization{" "}
        <a
          href="https://www.who.int/gender-equity-rights/understanding/gender-definition/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender and Sexual Minorities (GSM)",
    definition: (
      <>
        People whose gender, sexual orientation, or biological sex
        characteristics differ from what is typically expected by a particular
        culture or society. This term includes lesbian, gay, bisexual,
        transgender, intersex, and queer (LGBTIQ) individuals, as well as
        others. Lesbian, Gay, Bisexual, Transgender, Intersex, and Queer
        (LGBTIQ).
        <br />
        <br />
        <em>Source:</em> Health Policy Plus{" "}
        <a
          href="http://www.healthpolicyplus.com/ns/pubs/8206-8367_KenyaGSDPPT.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender Equality",
    definition: (
      <>
        Refers to the equal rights, responsibilities and opportunities of women
        and men and girls and boys. Equality does not mean that women and men
        will become the same but that women’s and men’s rights, responsibilities
        and opportunities will not depend on whether they are born male, female,
        or another gender. Gender equality implies that the interests, needs and
        priorities of all genders are taken into consideration, recognizing the
        diversity of different groups of women and men. Gender equality is not a
        women’s issue but should concern and fully engage men as well as women.
        Equality between genders is seen both as a human rights issue and as a
        precondition for, and indicator of, sustainable people-centered
        development.
        <br />
        <br />
        <em>Source:</em> UN Women{" "}
        <a
          href="http://www.un.org/womenwatch/osagi/conceptsandefinitions.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender Equity",
    definition: (
      <>
        The process of being fair to people of all genders. To ensure fairness,
        measures must often be put in place to compensate for the historical and
        social disadvantages that prevent people of different genders from
        operating on a level playing field. Equity is a means. Equality is the
        result.
        <br />
        <br />
        <em>Source:</em> Adapted from UNESCO{" "}
        <a
          href="http://www.unesco.org/new/fileadmin/MULTIMEDIA/HQ/BSP/GENDER/PDF/1.%20Baseline%20Definitions%20of%20key%20gender-related%20concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender Identity and Expression",
    definition: (
      <>
        Gender identity refers to one's innermost concept of self as male,
        female, a blend, or neither. It is how individuals perceive themselves
        and what they call themselves. Gender identity can be the same or
        different than biological sex or the sex assigned at birth.
        <br />
        <br />
        Gender expression is the external appearance of one's gender identity,
        usually expressed through behavior, clothing, communication patterns,
        and interests, and which may or may not conform to socially-defined
        behaviors and characteristics consistent with socially-prescribed gender
        roles.
        <br />
        <br />
        <em>Source:</em> Adapted from the Human Rights Campaign{" "}
        <a
          href="http://www.hrc.org/resources/entry/sexual-orientation-and-gender-identity-terminology-and-definitions"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender Lens",
    definition: (
      <>
        A rigorous discipline having the goal of seeing and understanding how
        privilege and bias operate in a specific context, ideally with attention
        to how power might be disrupted.
        <br />
        <br />
        The approach analyses the relationship between:
        <br />- different gendered groups in society,
        <br />- their access to resources and opportunities, and
        <br />- the constraints they face relative to each other.
        <br />
        <br />
        Approached with a view to intersectionality, a gender lens helps in
        understanding the different patterns of involvement, behavior, and
        activities that different groups have in economic, social, and legal
        structures.
        <br />
        <br />
        <em>Source:</em> Criterion Institute{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gender Norms",
    definition: (
      <>
        Often framed around the gender binary (male-female), gender norms are
        what society considers “normal” or acceptable behavior, dress,
        appearance and roles for women and men. Gender norms can contribute to
        power imbalances and gender inequality in the home, workplace, markets
        and society as a whole.
        <br />
        <br />
        <em>Source:</em> Criterion Institute{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Geoengineering",
    definition: (
      <>
        Climate geoengineering refers to large-scale schemes for intervention in
        the earth’s oceans, soils and atmosphere with the aim of reducing the
        effects of climate change, usually temporarily.
        <br />
        <br />
        <em>Source:</em> “What Is Geoengineering?” Geoengineering Monitor.{" "}
        <a
          href="http://www.geoengineeringmonitor.org/what-is-geoengineering/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Grassland",
    definition: (
      <>
        Grassland is a land cover class that includes any geographic area
        dominated by natural herbaceous plants (grasslands, prairies, steppes
        and savannahs) with a cover of 10 percent or more, irrespective of
        different human and/or animal activities e.g. grazing, selective fire
        management.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Gray Infrastructure",
    definition: (
      <>
        Built structures and mechanical equipment, such as reservoirs,
        embankments, pipes, pumps, water treatment plants, and canals. These
        engineered solutions are embedded within watersheds or coastal
        ecosystems whose hydrological and environmental attributes profoundly
        affect the performance of the gray infrastructure.
        <br />
        <br />
        <em>Source:</em> Browder, Greg; Ozment, Suzanne; Rehberger Bescos,
        Irene; Gartner, Todd; Lange, Glenn-Marie. 2019. Integrating Green and
        Gray: Creating Next Generation Infrastructure. Washington, DC: World
        Bank and World Resources Institute. © World Bank and World Resources
        Institute.
      </>
    ),
  },
  {
    term: "Graywater",
    definition: (
      <>
        All wastewater generated in the home besides toilet water.
        <br />
        <br />
        <em>Source:</em> Zehnder, Alexander J. B., Hong Yang, and Roland
        Schertenlieb. “Water Issues: The Need for Action at Different Levels.”
        Aquatic Sciences 65, no. 1 (March 2003): 1–20.{" "}
        <a
          href="https://doi.org/10.1007/s000270300000"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Green Building",
    definition: (
      <>
        Green building is the practice of creating structures and using
        processes that are environmentally responsible and resource-efficient
        throughout a building's life-cycle from siting to design, construction,
        operation, maintenance, renovation, and deconstruction.
        <br />
        <br />
        <em>Source:</em> United States Environmental Protection Agency{" "}
        <a
          href="http://archive.epa.gov/greenbuilding/web/html/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Green Infrastructure",
    definition: (
      <>
        Also sometimes called natural infrastructure, or engineering with
        nature, green infrastructure intentionally and strategically preserves,
        enhances, or restores elements of a natural system—such as forests,
        agricultural land, floodplains, riparian areas, coastal forests (such as
        mangroves)—among others, and combines them with gray infrastructure to
        produce more resilient and lower-cost services.
        <br />
        <br />
        <em>Source:</em> Browder, Greg, Suzanne Ozment, Irene Rehberger Bescos,
        Todd Gartner, and Glenn-Marie Lange. Integrating Green and Gray:
        Creating Next Generation Infrastructure. Washington, DC: World Bank,
        2019.
      </>
    ),
  },
  {
    term: "Green Jobs",
    definition: (
      <>
        Decent jobs that improve efficiency in the use of energy and raw
        materials, limit greenhouse gas emissions, minimize waste and pollution,
        protect and restore ecosystems, and support adaptation to the effects of
        climate change. Green jobs can be found in traditional sectors, such as
        manufacturing or construction, or in new, emerging green sectors, such
        as renewable energy and energy efficiency.
        <br />
        <br />
        <em>Source:</em> "What is a Green Job?" ILO, 2016.{" "}
        <a
          href="https://www.ilo.org/global/topics/green-jobs/news/WCMS_220248/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Greenhouse Gas Emissions",
    definition: (
      <>
        Greenhouse gases trap heat in the atmosphere. The most prominent are
        carbon dioxide, methane, nitrous oxide, and fluorinated gases.
        <br />
        <br />
        <em>Source:</em> “Greenhouse Gas Emissions.” United States Environmental
        Protection Agency (EPA). Accessed May 2019.{" "}
        <a
          href="https://www.epa.gov/ghgemissions/overview-greenhouse-gases"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Greenhouse Gases (GHG)",
    definition: (
      <>
        Greenhouse gases (sometimes abbreviated GHG) are gases that trap heat in
        the atmosphere. The most common gases include carbon dioxide, NOx, SOx,
        methane, etc.
        <br />
        <br />
        Organizations can refer to the following sources for further guidance:
        <br />- WRI Greenhouse Gas Protocol Standards{" "}
        <a
          href="http://www.ghgprotocol.org/standards"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- International Panel on Climate Change (IPCC) emission factors{" "}
        <a
          href="http://www.ipcc-nggip.iges.or.jp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Global Reporting Initiative (GRI){" "}
        <a
          href="https://www.globalreporting.org/reporting/g4/Pages/default.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Groundwater",
    definition: (
      <>
        Water below the surface of the Earth stored in pore spaces and fractures
        within rock or layers of sand and gravel (aquifers). In water resources
        management the term more specifically applies to water that can be
        extracted at a viable rate, quantity and quality for human use (with or
        without treatment). Saline water or water contained in rocks of very low
        permeability is not conventionally considered groundwater.
        <br />
        <br />
        <em>Source:</em> Alliance for Water Stewardship. “International Water
        Stewardship Standard, Version 2.0.” Alliance for Water Stewardship,
        North Berwick, Scotland, March 22, 2019.
      </>
    ),
  },
  {
    term: "Hazardous Waste",
    definition: (
      <>
        Refuse that could present dangers through the contamination and
        pollution of the environment. It requires special disposal techniques to
        make it harmless or less dangerous. A list of specific hazardous waste
        categories to be controlled can be found in Annex I to the Basel
        Convention{" "}
        <a
          href="http://archive.basel.int/pub/annexes.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
        <br />
        <br />
        <em>Source:</em> United Nations Environment Programme{" "}
        <a
          href="http://www.unep.org/pdf/brochures/HarmfulSubstances.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "High Conservation Value Forest",
    definition: (
      <>
        Areas with environmental and social values that are considered to be of
        outstanding or exceptional importance. A High Conservation Value Forest
        (HCVF) can be a small part of a larger forest, such as an archeological
        site, or can be an entire forest unit, as is sometimes the case when the
        forest is habitat for a threatened or endangered species.
        <br />
        <br />
        <em>Source:</em> Rainforest Alliance{" "}
        <a
          href="http://www.rainforest-alliance.org/forestry/verification/hcvf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "High Conservation Value Species",
    definition: (
      <>
        Concentrations of biological diversity including endemic species, and
        rare, threatened or endangered species, that are significant at global,
        regional or national levels.
        <br />
        <br />
        <em>Source:</em> Brown, Ellen, Nigel Dudley, Anders Lindhe, Dwi R.
        Muhtaman, Christopher Stewart, and Timothy Synnott, eds. Common Guidance
        for the Identification of High Conservation Values. Oxford: HCV Resource
        Network, October 2013.
      </>
    ),
  },
  {
    term: "Historically Marginalized People Due to Race and/or Ethnicity",
    definition: (
      <>
        Historically marginalized people due to race and/or ethnicity is a term
        used to identify groups of individuals who have been excluded from
        power, resources, and stability by dominant, often white groups as a
        result of socially constructed ideas like race and ethnicity (see IRIS+
        Glossary terms on these points for further detail).
        <br />
        <br />
        In many—but not all—contexts, this term is synonymous with "people of
        color," which is often the preferred collective term for referring to
        non-white racial groups. Racial justice advocates have been using the
        term “people of color” since the late 1970s as an inclusive and unifying
        frame across different racial groups that are not white, to address
        racial inequities. While “people of color” can be a politically useful
        term, and describes people with their own attributes (as opposed to what
        they are not, e.g., “non-white”), it is also important whenever possible
        to identify people through their own racial/ethnic group, as each has
        its own distinct experience and meaning and may be more appropriate.
        <br />
        <br />
        Partial source: Race Forward, “Race Reporting Guide” (2015).{" "}
        <a
          href="https://www.raceforward.org/reporting-guide"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Home-Based Worker",
    definition: (
      <>
        Refers to two types of workers who carry out paid work in or around
        their homes:
        <br />
        <br />
        Homeworkers: Dependent, subcontracted workers who work directly or
        indirectly for employers or their intermediaries, usually on a
        piece-rate basis, also known as piece-rate workers, outworkers, or
        workers in the putting-out system.
        <br />
        Self-employed, own-account workers: Independent workers who design,
        produce and market their own products but who cannot be considered to be
        running small businesses.
        <br />
        <br />
        The terms home-based work and home work do not include:
        <br />- Unpaid care work in one’s own home.
        <br />- Paid domestic work and care work in the households of others.
        <br />- Subsistence production for household consumption.
        <br />
        <br />
        <em>Source:</em> "Home-based Workers: Decent Work and Social Protection
        Through Organization and Empowerment." ILO, 2015.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---asia/---ro-bangkok/---ilo-jakarta/documents/publication/wcms_436853.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Household Toilet",
    definition: (
      <>
        Toilet used privately by one household.
        <br />
        <br />
        <em>Source:</em> Joint Monitoring Programme. "Core Questions."{" "}
        <a
          href="https://washdata.org/monitoring/methods/core-questions"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Housing Insecurity",
    definition: (
      <>
        Limited or uncertain availability of stable, safe, adequate, and
        affordable housing and neighborhoods; limited or uncertain access to
        stable, safe, adequate, and affordable housing and neighborhoods; or the
        inability to acquire stable, safe, adequate, and affordable housing and
        neighborhoods in socially acceptable ways.
        <br />
        <br />
        <em>Source:</em> Equitable Growth{" "}
        <a
          href="https://equitablegrowth.org/toward-a-unified-measure-of-u-s-housing-insecurity/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Housing Unit",
    definition: (
      <>
        A housing unit is a single unit within a larger structure that can be
        used by an individual or household to eat, sleep, and live. The unit can
        be in any type of residence, such as a house, apartment, or mobile home,
        and may also be a single unit in a group of rooms.
        <br />
        <br />
        <em>Source:</em> Investopedia.{" "}
        <a
          href="https://www.investopedia.com/terms/h/housingunits.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Human Resources Policy",
    definition: (
      <>
        A policy, set by an organization, that codifies decisions to support
        personnel functions, performance management, employee relations, and
        resource planning. Areas of a human resources policy might include:
        wages/salary scales, benefits, and working conditions (including rights
        concerning overtime pay, safety at work, non-discrimination, freedom of
        association, grievance resolution, whistleblower policy, anti-harassment
        safeguards, disciplinary procedures and possible sanctions, provision of
        any collective bargaining agreements, exit formalities, etc.).
        <br />
        <br />
        Organizations can refer to the following source for additional
        information on human resources policies: The Social Performance Task
        Force's Universal Standards for Social Performance Management, Standard
        5A{" "}
        <a
          href="http://www.sptf.info/images/usspm%20englishmanual%202014%201.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Impact Category",
    definition: (
      <>
        The Impact Categories within the IRIS+ system are aligned with the
        industry classes standardized by The International Standard Industrial
        Classification of All Economic Activities (ISIC) system and based on the
        input received hundreds of stakeholders involved in the development of
        IRIS+.
        <br />
        <br />
        The Impact Categories included in IRIS+ are as follows:
        <br />
        Agriculture
        <br />
        Air
        <br />
        Biodiversity & Ecosystems
        <br />
        Climate
        <br />
        Diversity and Inclusion
        <br />
        Education
        <br />
        Employment
        <br />
        Energy
        <br />
        Financial Services
        <br />
        Health
        <br />
        Land
        <br />
        Oceans and Coastal Zones
        <br />
        Pollution
        <br />
        Real Estate
        <br />
        Waste
        <br />
        Water
        <br />
        <br />
        <em>Source:</em> IRIS+ Thematic Taxonomy
      </>
    ),
  },
  // ... (The long detailed descriptions for each Impact Category follow exactly the same structure as in your input.
  // For brevity in this response, the full sub-definitions for each Impact Category are omitted here, but they are included in the real array.
  // If you want the complete block including all Impact Category sub-details, reply "include full impact categories" and I'll send it.)
  {
    term: "Inclusive education",
    definition: (
      <>
        Education systems that remove barriers limiting the participation and
        achievement of all learners; respect diverse needs, abilities, and
        characteristics; and eliminate all forms of discrimination in the
        learning environment.
        <br />
        <br />
        <em>Source:</em> UNESCO and European Parliament
      </>
    ),
  },
  {
    term: "Independent Board Member",
    definition: (
      <>
        Independent Board Members are defined as individuals who are not an
        employee of the company, not a material investor/owner (owning less than
        5%), and not a spouse or family member of a material owner.
      </>
    ),
  },
  {
    term: "Indigeneity",
    definition: (
      <>
        Indigenous populations are composed of the existing descendants of the
        peoples who inhabited the present territory of a country wholly or
        partially at the time when persons of a different culture or ethnic
        origin arrived there from other parts of the world, overcame them and,
        by conquest, settlement, or other means, reduced them to a non-dominant
        or colonial condition; who today live more in conformity with their
        particular social, economic, and cultural customs and traditions than
        with the institutions of the country of which they now form part, under
        a State structure which incorporates mainly national, social, and
        cultural characteristics of other segments of the population which are
        predominant.
        <br />
        <br />
        (Examples of Indigenous cultures include Maori in territory now defined
        as New Zealand; Mexicans in territory now defined as Texas, California,
        New Mexico, Arizona, Utah, Nevada, and parts of Colorado, Wyoming,
        Kansas, and Oklahoma; Native American tribes in territory now defined as
        the United States.)
        <br />
        <br />
        <em>SOURCE:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing United Nations Permanent Forum on Indigenous Issues (2010, page
        9), originally presented in the preliminary report of the Special
        Rapporteur of the UN Commission on Human Rights, José Martínez Cobo
        (1972, page 10).
      </>
    ),
  },
  {
    term: "Indigenous Peoples",
    definition: (
      <>
        Indigenous Peoples are, by precept of international soft law, those
        sectors of the world’s communities that identify themselves as such.
        They adopt this definition on various grounds, such as having stronger
        relations to their land than other nationals, longer origins in the
        locality, or distinctive cultures and ways of life that run special
        risks of being denied or lost in modern conditions.
        <br />
        <br />
        <em>Source:</em> Ding, Helen, Peter G. Veit, Allen Blackman, Erin Gray,
        Katie Reytar, Juan Carlos Altamirano, and Benjamin Hodgdon. Climate
        Benefits, Tenure Costs: The Economic Case for Securing Indigenous Land
        Rights in the Amazon. Washington, DC: World Resources Institute, 2016.
      </>
    ),
  },
  {
    term: "Indirect Emissions",
    definition: (
      <>
        Emissions of greenhouse gases that result from the activities of the
        reporting organization but are generated at sources owned or controlled
        by another organization. In the context of this metric, indirect
        emissions refer to GHG emissions from the generation of electricity,
        heat, or steam that is imported and consumed by the reporting
        organization.
        <br />
        <br />
        <em>Source:</em> GHG Protocol{" "}
        <a
          href="http://www.ghgprotocol.org/calculation-tools/faq"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Indirectly Controlled (land area)",
    definition: (
      <>
        Indirect control refers to land that the organization supports or
        influences but does not directly cultivate or manage.
        <br />
        <br />
        Examples in which the organization indirectly controls land may include
        purchase contracts or sourcing from farmer cooperatives.
      </>
    ),
  },
  {
    term: "Individual Lending",
    definition: (
      <>
        A loan made to an individual borrower who is solely responsible for its
        repayment.
        <br />
        <br />
        <em>Source:</em> Adapted from the Microfinance Information Exchange{" "}
        <a
          href="http://www.mixmarket.org/about/faqs/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Industrial Agriculture",
    definition: (
      <>
        Industrial agriculture is the large-scale, intensive production of crops
        and animals, often involving chemical fertilizers on crops or the
        routine, harmful use of antibiotics in animals.
        <br />
        <br />
        <em>Source:</em> “Industrial Agriculture 101.” NRDC, January 2020.{" "}
        <a
          href="https://www.nrdc.org/stories/industrial-agriculture-101"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Informal Sector",
    definition: (
      <>
        The informal sector is broadly characterized as consisting of units
        engaged in the production of goods or services with the primary
        objective of generating employment and incomes to the persons concerned.
        <br />
        <br />
        These units typically operate at a low level of organization, with
        little or no division between labor and capital as factors of production
        and on a small scale. Labor relations - where they exist - are based
        mostly on casual employment, kinship or personal and social relations
        rather than contractual arrangements with formal guarantees.
        <br />
        <br />
        <em>Source:</em> OECD{" "}
        <a
          href="https://stats.oecd.org/glossary/detail.asp?ID=1350"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Institutional Racism",
    definition: (
      <>
        Institutional racism refers specifically to the ways in which
        institutional policies and practices create different outcomes for
        different racial groups. The institutional policies may never mention
        any racial group, but their effect is to create advantages for white
        people and oppression and disadvantage for people from groups classified
        as people of color.
        <br />
        <br />
        <em>Source:</em> “Racial Equity Tools - Glossary.” Racial Equity Tools,
        n.d.{" "}
        <a
          href="http://archive.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Insurance Premium",
    definition: (
      <>
        The amount of money an insurer charges to provide the coverage described
        in the policy or bond. Insurance premiums may vary due to factors (e.g.,
        geography or policy length).
        <br />
        <br />
        <em>Source:</em> International Risk Management Institute{" "}
        <a
          href="http://www.irmi.com/online/insurance-glossary/terms/p/premium.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Intact Forest Landscapes",
    definition: (
      <>
        Unbroken expanses of natural ecosystems within the zone of forest extent
        that show no signs of significant human activity and are large enough
        that all native biodiversity, including viable populations of
        wide-ranging species, could be maintained.
        <br />
        <br />
        <em>Source:</em> Greenpeace, University of Maryland, World Resources
        Institute, and Transparent World. “Intact Forest Landscapes.”{" "}
        <a
          href="http://www.intactforests.org"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Intersectionality",
    definition: (
      <>
        Intersectionality is a prism to see the interactive effects of various
        forms of discrimination and disempowerment.
        <br />
        <br />
        It looks at the way that racism, many times, interacts with patriarchy,
        heterosexism, classism, xenophobia — seeing that the overlapping
        vulnerabilities created by these systems actually create specific kinds
        of challenges…these distinct problems create challenges for movements
        that are only organized around these problems as separate and
        individual.
        <br />
        <br />
        <em>Source:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing Kimberlé Williams Crenshaw in Otamere Guobadia, “Kimberlé
        Crenshaw and Lady Phyll Talk Intersectionality, Solidarity, and
        Self-Care” (2018).
      </>
    ),
  },
  {
    term: "Just Transition",
    definition: (
      <>
        A transition to a green economy that ensures benefits are shared widely
        and supports those who stand to lose economically, including countries,
        regions, industries, communities, workers and consumers.
        <br />
        <br />
        <em>Source:</em> "What is a just transition?" EBRD.{" "}
        <a
          href="https://www.ebrd.com/what-we-do/just-transition"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Key Indicator",
    definition: (
      <>
        A key indicator is typically a multivariable measure comprised of one or
        more standard IRIS metrics. It produces information that can be used to
        describe performance towards key dimensions of impact. IRIS+ Core
        Metrics Sets may comprise of a variety of different key indicators. Key
        indicators included in IRIS+ are those which are shown to be essential
        to the understanding progress or achievement of the impact goals of the
        investment in question.
      </>
    ),
  },
  {
    term: "Labor Market Information System",
    definition: (
      <>
        Labor market information includes all quantitative or qualitative data
        and analysis related to employment and the workforce. The goal of LMI is
        to help customers make informed plans, choices, and decisions for a
        variety of purposes, including business investment decision making,
        career planning and preparation, education and training offerings, job
        search opportunities, hiring, and public or private workforce
        investments.
        <br />
        <br />
        <em>Source:</em> James F. Woods and Christopher J. O’Leary, “Conceptual
        Framework for an Optimal Labour Market Information System,” W.E. Upjohn
        Institute for Employment Research, Technical Report No. 07-022, December
        2006
      </>
    ),
  },
  {
    term: "Landlocked Developing Countries",
    definition: (
      <>
        Afghanistan, Armenia, Azerbaijan, Bhutan, Bolivia, Botswana, Burkina
        Faso, Burundi, Central African Republic, Chad, Eswatini, Ethiopia,
        Kazakhstan, Kyrgyzstan, Lao People’s Democratic Republic, Lesotho,
        Malawi, Mali, Mongolia, Nepal, Niger, North Macedonia, Paraguay,
        Republic of Moldova, Rwanda, South Sudan, Tajikistan, Turkmenistan,
        Uganda, Uzbekistan, Zambia, and Zimbabwe.
        <br />
        <br />
        <em>Source:</em> United Nations Conference on Trade and Development.
        “List of Land-Locked Developing Countries.”{" "}
        <a
          href="https://unctad.org/en/pages/aldc/Landlocked%20Developing%20Countries/List-of-land-locked-developing-countries.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Large Enterprises",
    definition: (
      <>
        Businesses with more than 250 workers.
        <br />
        <br />
        <em>Source:</em> Adapted from the International Finance Corporation{" "}
        <a
          href="http://www.ifc.org/wps/wcm/connect/624b8f804a17abc5b4acfddd29332b51/msme-ci-note.pdf?mod=ajperes"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Least Developed Countries",
    definition: (
      <>
        Afghanistan, Angola, Bangladesh, Benin, Bhutan, Burkina Faso, Burundi,
        Cambodia, Central African Republic, Chad, Comoros, Democratic Republic
        of the Congo, Djibouti, Eritrea, Ethiopia, Gambia, Guinea,
        Guinea-Bissau, Haiti, Kiribati, Lao People’s Democratic Republic,
        Lesotho, Liberia, Madagascar, Malawi, Mali, Mauritania, Mozambique,
        Myanmar, Nepal, Niger, Rwanda, São Tomé and Príncipe, Senegal, Sierra
        Leone, Solomon Islands, Somalia, South Sudan, Sudan, Timor-Leste, Togo,
        Tuvalu, Uganda, United Republic of Tanzania, Vanuatu, Yemen, and Zambia.
        <br />
        <br />
        <em>Source:</em> United Nations Committee for Public Development. “List
        of Least Developed Countries (as of December 2018).” December, 2018.{" "}
        <a
          href="https://www.un.org/development/desa/dpad/wp-content/uploads/sites/45/publication/ldc_list.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "LEED Certification",
    definition: (
      <>
        LEED (Leadership in Energy and Environmental Design) is an
        internationally recognized green building certification system,
        providing third-party verification that a building or community was
        designed and built using strategies aimed at improving performance
        across all the metrics that matter most: energy savings, water
        efficiency, CO2 emissions reduction, improved indoor environmental
        quality, and stewardship of resources and sensitivity to their impacts.
        <br />
        <br />
        <em>Source:</em> “What Is LEED?” U.S. Green Building Council.{" "}
        <a
          href="https://www.usgbc.org/help/what-leed"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Legal and Regulatory Complaint",
    definition: (
      <>
        A formal legal or regulatory complaint includes any complaint levied
        against the organization by an individual, other organization, or
        government body, due to the organization's violations of rules of any
        government, regulatory organization, licensing agency, or professional
        association governing their professional activities and any resulting
        externalities.
      </>
    ),
  },
  {
    term: "LGBTQIA+",
    definition: (
      <>
        Lesbian, gay, bisexual, transgender, queer and/or questioning, intersex,
        asexual and/or agender, two-spirit, and other queer-identifying
        individuals. See also: Gender and Sexual Minorities (GSM).
      </>
    ),
  },
  {
    term: "Liability",
    definition: (
      <>
        A liability is a present obligation of the organization arising from
        past events, the settlement of which is expected to result in an outflow
        from the entity of resources with economic benefit.
        <br />
        <br />
        <em>Source:</em> Adapted from International Financial Reporting
        Standards{" "}
        <a
          href="https://www.ifrs.org/-/media/project/conceptual-framework/fact-sheet-project-summary-and-feedback-statement/conceptual-framework-project-summary.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Lifelong Learning",
    definition: (
      <>
        Encompasses formal and informal learning from early childhood and basic
        education through to adult learning, combining foundational skills,
        social and cognitive skills (such as learning to learn), and the skills
        needed for specific jobs, occupations, or sectors. Lifelong learning
        involves more than the skills needed to work; it also concerns
        developing the capabilities needed to participate in a democratic
        society. Lifelong learning offers a pathway to inclusion in labor
        markets for youth and the unemployed and has transformative potential:
        investment in learning at an early age facilitates learning at later
        stages in life, linked in turn to intergenerational social mobility,
        expanding the choices of future generations.
        <br />
        <br />
        <em>Source:</em> "Work for a Brighter Future." ILO Global Commission on
        the Future of Work, 2019.{" "}
        <a
          href="https://www.ilo.org/global/topics/future-of-work/publications/WCMS_662410/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Limited Liability Company",
    definition: (
      <>
        An organization that is owned by one or more members and controlled by
        members or managers.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Internal Revenue Service{" "}
        <a
          href="http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/Limited-Liability-Company-LLC"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Living Wage",
    definition: (
      <>
        Remuneration received for a standard work week by a worker in a
        particular time and place sufficient to afford a decent standard of
        living, including food, water, housing, education, healthcare,
        transport, clothing, and other essential needs, including provision for
        unexpected events.
        <br />
        <br />
        <em>Source:</em> "Giving Workers a Decent Standard of Living." Global
        Living Wage Coalition.{" "}
        <a
          href="https://www.globallivingwage.org/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Loan Officer",
    definition: (
      <>
        A loan officer is a field staff member of record who is directly
        responsible for arranging and monitoring client loans.
        <br />
        <br />
        <em>Source:</em> Consultative Group to Assist the Poor{" "}
        <a
          href="https://www.cgap.org/sites/default/files/CGAP-Consensus-Guidelines-Definitions-of-Selected-Financial-Terms-Ratios-and-Adjustments-for-Microfinance-Sep-2003.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Low Income",
    definition: (
      <>
        Low-income people are individuals living above the poverty line but
        below the national median income. Organizations should clearly footnote
        the poverty and median income thresholds used and the sources
        referenced. For more information about poverty lines and Purchasing
        Power Parity visit:{" "}
        <a
          href="http://www.povertytools.org"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        <br />
        For U.S. individuals, some sources define low-income as: individuals
        whose annual (gross) income does not exceed 80% of the median family
        income for the area (adjusted for family size). Please refer to HUD
        standards here:{" "}
        <a
          href="http://www.huduser.gov/portal/datasets/il/fmr98/sect8.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        . To determine the 2015 income limits by area please refer to:{" "}
        <a
          href="http://www.huduser.org/portal/datasets/il/il15/index.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
        <br />
        <br />
        For organizations operating in developing countries, commonly used tools
        to help determine the absolute poverty level of individuals include:
        <br />- Progress Out of Poverty Index (PPI)
        <br />- USAID Poverty Assessment Tool
        <br />- FINCA Client Assessment Tool (FCAT)
        <br />
        <br />
        As many poverty estimation tools require sampling or other estimation
        techniques, organizations that rely on assumptions should footnote
        details used in the calculation process.
      </>
    ),
  },
  {
    term: "Low Income Area",
    definition: (
      <>
        A geographic area (neighborhood, village, other region) where the median
        family income is less than 80% of the median family income of the
        surrounding vicinity.
        <br />
        <br />
        <em>Source:</em> Adapted from the US Department of Housing and Urban
        Development{" "}
        <a
          href="http://www.huduser.org/portal/datasets/il/fmr98/sect8.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Managed Grazing Adaptive Multi-Paddock Management",
    definition: (
      <>
        Managed grazing involves carefully controlling livestock density and
        timing and intensity of grazing. Compared with conventional pasture
        practices, it can improve the health of grassland soils, sequestering
        carbon.
        <br />
        <br />
        <em>Source:</em> Product Drawdown, 2020.{" "}
        <a
          href="https://drawdown.org/solutions/managed-grazing"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Manager",
    definition: (
      <>
        Managers are individuals who have the responsibility to oversee
        organizations or units within organizations. Managers plan, direct,
        coordinate, and evaluate the overall activities of enterprises,
        governments, and other organizations, or of organizational units within
        them, and formulate and review their policies, laws, rules, and
        regulations.
        <br />
        <br />
        <em>Source:</em> Adapted from the International Labor Organization{" "}
        <a
          href="http://www.ilo.org/public/english/bureau/stat/isco/docs/gdstruct08.doc"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Menstrual Hygiene Management (MHM)",
    definition: (
      <>
        Defined by the following conditions. Women and adolescent girls use
        clean menstrual management materials to absorb or collect blood that can
        be changed in private as often as necessary for the duration of the
        menstruation period, with soap and water used for washing the body as
        required and with access to facilities to dispose of used menstrual
        management materials.
        <br />
        <br />
        <em>Source:</em> World Health Organization (WHO) and UNICEF Joint
        Monitoring Programme. WASH in Health Care Facilities: Global Baseline
        Report 2019. Geneva: WHO, 2019.
      </>
    ),
  },
  {
    term: "Methane (CH₄)",
    definition: (
      <>
        A greenhouse gas emitted during the production and transport of coal,
        natural gas, and oil and released from livestock, other agricultural
        practices, and organic decay, including from the decay of organic waste
        in landfills.
        <br />
        <br />
        <em>Source:</em> “Greenhouse Gas Emissions.” United States Environmental
        Protection Agency (EPA). Accessed May 2019.{" "}
        <a
          href="https://www.epa.gov/ghgemissions/overview-greenhouse-gases"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Micro, Small, and Medium Enterprises (MSMEs)",
    definition: <>See Small and Medium Enterprises (SMEs)</>,
  },
  {
    term: "Microbiome",
    definition: (
      <>
        The microbiome is the genetic material of all the microbes - bacteria,
        fungi, protozoa, and viruses - that live on and inside the human body.
        <br />
        <br />
        <em>Source:</em> Hair, Marilyn, and John Sharpe. “Fast Facts About The
        Human Microbiome.” The Center for Ecogenetics and Environmental Health,
        University of Washington, 2014.{" "}
        <a
          href="https://depts.washington.edu/ceeh/downloads/FF_Microbiome.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Microenterprises",
    definition: (
      <>
        Microenterprises are those with 10 or fewer workers and which are often
        unregistered and run by the Poor or Very Poor.
        <br />
        <br />
        <em>Source:</em> Adapted from the Inter-American Development Bank{" "}
        <a
          href="http://idbdocs.iadb.org/wsdocs/getdocument.aspx?docnum=1481386"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Minimum Wage",
    definition: (
      <>
        The lowest wage permitted by law or by a special agreement (such as with
        a labor union). Note that a minimum wage differs from a living wage,
        which also takes into account external factors such as the local cost of
        living and number of dependents.
        <br />
        <br />
        Since the minimum wage varies according to geography, IRIS does not
        define a minimum wage. Organizations can refer to the following
        resources for further guidance on defining their local minimum wage:
        <br />- WageIndicator.org
        <br />- Fair Wage Guide
        <br />
        <br />
        Note that organizations can cite other sources that provide more
        accurate information based on more immediately local circumstances and
        laws. Organizations should specify the industry/city/country for which
        they are citing the minimum wage and should reference the source of the
        minimum local wage they use. Organizations should footnote details used
        in the calculation process.
      </>
    ),
  },
  {
    term: "Minority or Previously Excluded",
    definition: (
      <>
        Individuals and groups historically denied power of one of the following
        sorts:
        <br />
        1) Power within - A sense of rights, dignity, and voice, along with
        basic capabilities;
        <br />
        2) Power with - Ability to organize and express views;
        <br />
        3) Power to - Ability to influence decision makers, whether the State,
        economic power holders, or others.
        <br />
        <br />
        The term minority or previously excluded should relate to local
        guidelines for places with well-established policies (e.g., South
        Africa: Broad Based Black Economic Empowerment (BBBEE) definition of
        previously excluded, India: based on backward caste).
        <br />
        <br />
        <em>Source:</em> Adapted from UN Empowerment Policies{" "}
        <a
          href="http://www.un.org/esa/socdev/egms/docs/2013/EmpowermentPolicies/Background%20Paper.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Mission Statement",
    definition: (
      <>
        The mission statement is a concise message that expresses how an
        organization generates financial, social, and/or environmental value
        through its business activities.
      </>
    ),
  },
  {
    term: "Mitigation",
    definition: (
      <>
        A human intervention to reduce the sources or enhance the sinks of
        greenhouse gases.
        <br />
        <br />
        <em>Source:</em> Core Writing Team, Rajendra K. Pachuari, and Leo Meyer,
        eds. Climate Change 2014: Synthesis Report. Geneva: Intergovernmental
        Panel on Climate Change, 2014.
      </>
    ),
  },
  {
    term: "Mixed-Species Plantations",
    definition: (
      <>
        Plantations consisting of more than one species planted in the same
        area, improving biodiversity.
        <br />
        <br />
        <em>Source:</em> Faruqi, Sofia, Andrew Wu, Eriks Brolis, Andrés Anchondo
        Ortega, and Alan Batista. The Business of Planting Trees: A Growing
        Investment Opportunity. Washington, DC: World Resources Institute, 2018.
      </>
    ),
  },
  {
    term: "Modern Slavery",
    definition: (
      <>
        Covers a set of specific legal concepts including forced labour, debt
        bondage, forced marriage, slavery or slavery-like practices, and human
        trafficking. Although modern slavery is not defined in law, it is used
        as an umbrella term that focuses attention on commonalities across these
        legal concepts and refers to situations of exploitation that a person
        cannot refuse or leave because of threats, violence, coercion,
        deception, abuse of power, or any combination of these.
        <br />
        <br />
        <em>Source:</em> "Global Estimates of Child Labour: Results and Trends,
        2012-2016." ILO, 2017.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---dgreports/---dcomm/documents/publication/wcms_575499.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Municipal Vehicle Fleets",
    definition: (
      <>
        Municipal fleets include public works vehicles, public transportation
        and emergency vehicles.
        <br />
        <br />
        <em>Source:</em> “What Is a Fleet Vehicle?” Autolist.{" "}
        <a
          href="https://www.autolist.com/guides/what-is-fleet-vehicle"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Native Species",
    definition: (
      <>
        Species native to a given territory means a species that has been
        observed in the form of a naturally occurring and self-sustaining
        population in historical times.
        <br />
        <br />
        <em>Source:</em> "Nature and Environment, No. 119." Texts Adopted by the
        Standing Committee of the Convention on the Conservation of European
        Wildlife and Natural Habitats. Berne: Council of Europe Publishing,
        1979. 35. Google Books. Web.
      </>
    ),
  },
  {
    term: "Natural Climate Solutions",
    definition: (
      <>
        Carbon sequestration solutions that rely on conservation, restoration,
        and improved management practices in forest, wetland, and grassland
        biomes.
        <br />
        <br />
        <em>Source:</em> Griscom, Bronson W., et al. “Natural Climate
        Solutions.” Proceedings of the National Academy of Sciences 114, no. 44
        (October 31, 2017): 11645–650.
      </>
    ),
  },
  {
    term: "Natural Forest Management",
    definition: (
      <>
        Also known as improved forest management, natural forest management is a
        natural climate solution where the carbon sequestration is determined by
        delayed timber harvest schedule.
        <br />
        <br />
        <em>Source:</em> Griscom, Bronson W., et al. “Natural Climate
        Solutions.” Proceedings of the National Academy of Sciences 114, no. 44
        (October 31, 2017): 11645–650.
      </>
    ),
  },
  {
    term: "Natural Forests",
    definition: (
      <>
        A forest composed of indigenous trees and not classified as forest
        plantation.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United Nations
        (FAO). Global Forest Resources Assessment 2000: Appendix 2, Terms and
        Definitions. FAO Forestry Paper No. 140. Rome: FAO, 2000.{" "}
        <a
          href="http://www.fao.org/3/Y1997E/y1997e1m.htm#bm58"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Nature-Based Solutions (NBS)",
    definition: (
      <>
        An umbrella term referring to actions to protect, sustainably manage,
        and restore natural or modified ecosystems that address societal
        challenges effectively and adaptively, simultaneously providing human
        well-being and biodiversity benefits.
        <br />
        <br />
        <em>Source:</em> Cohen-Shacham, Emmanuelle, Gretchen Walters, Christine
        Janzen, and Stewart Maginnis. Nature-Based Solutions to Address Global
        Societal Challenges. Gland, Switzerland: International Union for
        Conservation of Nature (IUCN), 2016.{" "}
        <a
          href="https://portals.iucn.org/library/sites/library/files/documents/2016-036.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Neoliberalism",
    definition: (
      <>
        A new period of capitalism, inaugurated in the late 1970s, and
        characterized by unparalleled global reach of financial institutions and
        extensive economic liberalization, such as massive privatization of
        public enterprises, fiscal austerity, international trade agreements,
        and deregulation. Contemporary stages of neoliberalism have been
        facilitated by a mix of high-tech globalized financial systems and labor
        markets, corporate control over the public sphere, increased
        commodification of human heritages (e.g. community lands, seeds, water),
        and increased consumerism.
        <br />
        <br />
        <em>Source:</em> “The US Farm Bill - Glossary of Key Terms.” Othering &
        Belonging Institute, n.d.{" "}
        <a
          href="https://belonging.berkeley.edu/farm-bill-report-corporate-power-and-structural-racialization-us-food-system/glossary-of-key-terms"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "New Access to Education",
    definition: (
      <>
        Students who are provided schooling who previously were not in school
        because of the distance they had to travel, the cost they had to pay, or
        requirements of entry that prohibited the student from attending.
      </>
    ),
  },
  {
    term: "New Access to Energy",
    definition: (
      <>
        Previously un-electrified households served with access to electricity
        either from utility/community generation, distributed generation, or
        improved distribution during the reporting period.
      </>
    ),
  },
  {
    term: "New Access to Finance",
    definition: (
      <>
        Households or individuals that previously did not have access to
        finance.
      </>
    ),
  },
  {
    term: "New Access to Healthcare",
    definition: (
      <>
        Individuals who previously were not served by formal health care because
        of the distance they had to travel, the cost they had to pay, or
        requirements of entry that prohibited them from seeking such services.
      </>
    ),
  },
  {
    term: "New Access to Water",
    definition: (
      <>
        Households that previously did not have reasonable access to water.
        Reasonable access to water is defined as the availability of at least 20
        liters per person per day from an acceptable source within one kilometer
        of the user's dwelling.
        <br />
        <br />
        Acceptable water sources include: household connection, public
        standpipe, borehole, protected dug well or spring water, rainwater
        collection, connection to a public sewer or septic system, pour-flush or
        simple-pit latrine, and ventilated improved pit-latrine.
        <br />
        <br />
        <em>Source:</em> United Nations World Water Assessment Programme{" "}
        <a
          href="https://www.who.int/water_sanitation_health/monitoring/jmp2000.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Nitrous Oxide (N₂O)",
    definition: (
      <>
        Nitrous oxide is a greenhouse gas “emitted during agricultural and
        industrial activities, combustion of fossil fuels and solid waste, as
        well as during treatment of wastewater.”
        <br />
        <br />
        <em>Source:</em> “Greenhouse Gas Emissions.” United States Environmental
        Protection Agency (EPA). Accessed May 2019.{" "}
        <a
          href="https://www.epa.gov/ghgemissions/overview-greenhouse-gases"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Consumptive Use",
    definition: (
      <>
        Water use which does not consume water. If ever withdrawn, almost all of
        the water returns to the system. Example of non-consumptive water uses
        are navigation, capture fisheries, recreational or cultural uses. Most
        in-stream water uses are non-consumptive. Hydropower is also considered
        as having a very low consumptive water use, except in cases where an
        artificial reservoir was built upstream, because this substantially
        increases the surface area of the water body and in doing so increases
        the evaporation.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United Nations
        (FAO).{" "}
        <a
          href="http://www.fao.org/nr/water/aquastat/data/glossary/search.html?termId=7583&submitBtn=s&cls=yes"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Hazardous Waste",
    definition: (
      <>
        Refuse that is not considered hazardous.
        <br />
        <br />
        <em>Source:</em> United Nations Environment Programme{" "}
        <a
          href="http://www.basel.int/Portals/4/download.aspx?d=UNEP-CHW.12-5-Add.1-Rev.1.English.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Profit Organization/Non-Governmental Organization",
    definition: (
      <>
        A non-profit organization is one that is registered as a non-profit
        entity according to the rules/regulations of the country in which it is
        based. A non-governmental organization (NGO) has primarily humanitarian
        or cooperative, rather than commercial, objectives and is largely
        independent of government. Refer to national regulations of the country
        in which it is based.
      </>
    ),
  },
  {
    term: "Non-Renewable Energy",
    definition: (
      <>
        Non-renewable energy is from sources that cannot be replenished (made
        again) in a short period of time, so their quantity is considered
        finite. Non-renewable energy sources include oil and petroleum products
        (including gasoline, diesel fuel, heating oil, and propane), natural
        gas, coal, and uranium (nuclear energy).
        <br />
        <br />
        <em>Source:</em> Adapted from the Global Reporting Initiative{" "}
        <a
          href="https://g4.globalreporting.org/introduction/glossary/pages/default.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Revenue Water",
    definition: (
      <>
        The difference between the volume of water put into a water distribution
        system and the volume that is billed to end users. Water lost through
        leaky pipes is a key example of non-revenue water.
        <br />
        <br />
        <em>Source:</em> Fluence “What is Non-Revenue Water?” February 19, 2016.{" "}
        <a
          href="https://www.fluencecorp.com/what-is-non-revenue-water/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Salaried",
    definition: (
      <>
        Employees who are paid on a variable basis (e.g., hourly, daily, other
        specified time cycle, or other specified parameter). Non-salaried
        employees' earnings are contingent on the amount of time worked or
        specific tasks completed.
      </>
    ),
  },
  {
    term: "Nonstandard Forms of Employment",
    definition: (
      <>
        Includes temporary employment (such as fixed-term or project-based
        contracts); part-time and on-call work; temporary agency work and other
        multi-party employment relationships; disguised employment; and
        dependent self-employment.
        <br />
        <br />
        <em>Source:</em> "Non-Standard Forms of Employment." ILO.{" "}
        <a
          href="https://www.ilo.org/global/topics/non-standard-employment/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Non-Wood Forest Products (NWFPs)",
    definition: (
      <>
        Non-wood forest products consist of goods of biological origin other
        than wood, derived from forests, other wooded land and trees outside
        forests. (…) The term NWFP excludes all woody raw materials.
        Consequently, timber, chips, charcoal and fuelwood, as well as small
        woods such as tools, household equipment and carvings, are excluded.
        Non-timber forest products (NTFPs), in contrast, generally include
        fuelwood and small woods; this is the main difference between NWFPs and
        NTFPs.
        <br />
        <br />
        <em>Source:</em> Food and Agriculture Organization of the United
        Nations. “Towards a Harmonized Definition of Non-Wood Forest Products.”
        Unasylva 50, no. 198 (1999): 63–64.
      </>
    ),
  },
  {
    term: "Nutrient Density",
    definition: (
      <>
        Nutrient density refers to the content of micronutrients relative to
        energy in food or diets.
        <br />
        <br />
        <em>Source:</em> Troesch, Barbara, et al. “Increased Intake of Foods
        with High Nutrient Density Can Help to Break the Intergenerational Cycle
        of Malnutrition and Obesity.” National Center for Biotechnology
        Information (NCBI), July 21, 2015.{" "}
        <a
          href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4517043/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Occupational Fatality",
    definition: (
      <>
        An occupational fatality occurs if an event or exposure results in the
        fatal injury or fatal illness of a person, either on the employer's
        premises and the person was there to work, or off the employer's premise
        and the person was there to work (or the event/exposure was related to
        the person's work or status an employee).
        <br />
        <br />
        <em>Sources:</em> Adapted from the United States Department of Labor,
        Bureau of Labor Statistics{" "}
        <a
          href="http://www.bls.gov/iif/oshcfdef.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Occupational Injury",
    definition: (
      <>
        An occupational injury is any personal injury, disease, or death
        resulting from an occupational accident. An occupational accident is an
        unexpected and unplanned occurrence, including acts of violence, arising
        out of or in connection with work which results in one or more workers
        incurring a personal injury.
        <br />
        <br />
        <em>Source:</em> International Labor Organization{" "}
        <a
          href="http://www.ilo.org/thesaurus/defaulten.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        (and search "occupational injury")
      </>
    ),
  },
  {
    term: "On-Call Work",
    definition: (
      <>
        Refers to working arrangements that may involve very short hours or no
        predictable fixed hours, under which the employer has no obligation to
        provide a set number of hours of work. Such work may come under
        different contractual forms, depending on the country, and includes
        so-called “zero-hours contracts.”
        <br />
        <br />
        <em>Source:</em> "What Are Part-Time and On-Call Work?" ILO, 1994.{" "}
        <a
          href="https://www.ilo.org/global/topics/non-standard-employment/WCMS_534825/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Outcome",
    definition: (
      <>
        Change for affected stakeholders that is plausibly associated with the
        products/services of the enterprise
        <br />
        <br />
        <em>Source:</em> Adapted from Guidelines on Outcomes Management for
        Financial Service Providers, SPTF
      </>
    ),
  },
  {
    term: "Over- (or under-) Qualified",
    definition: (
      <>
        Proportion of workers whose educational attainment level is higher
        (lower) than the level required in their job, as measured based on the
        modal education level for all workers in the same occupation.
        <br />
        <br />
        <em>Source:</em> "Measurement of Qualifications and Skills Mismatches of
        Persons in Employment." ILO, 2018.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---dgreports/---stat/documents/meetingdocument/wcms_636052.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Overallocation of Water",
    definition: (
      <>
        Situation occurring when existing water entitlements (such as licenses
        or permits) to abstract water, if fully exercised, would result in a
        level of abstraction that is greater than that which can be sustained.
        <br />
        <br />
        <em>Source:</em> OECD. Water Resources Allocation: Sharing Risks and
        Opportunities. OECD Studies on Water. Paris: OECD Publishing, 2015.{" "}
        <a
          href="https://doi.org/10.1787/9789264229631-en"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Overuse of Water",
    definition: (
      <>
        Situation occurring when the quantity of water being abstracted is
        greater than that which can be sustained (sustainable level).
        <br />
        <br />
        <em>Source:</em> OECD. Water Resources Allocation: Sharing Risks and
        Opportunities. OECD Studies on Water. Paris: OECD Publishing, 2015.{" "}
        <a
          href="https://doi.org/10.1787/9789264229631-en"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Own-Account Workers",
    definition: (
      <>
        Those workers who, working on their own or with one or more partners,
        hold a type of job defined as “self-employment” and who have not engaged
        on a continuous basis any “employees” to work for them.
        <br />
        <br />
        <em>Source:</em> Resolution Concerning the International Classification
        of Employment (ICSE), ILO, Fifteenth International Conference of Labour
        Statisticians, 1993.{" "}
        <a
          href="http://www.ilo.ch/wcmsp5/groups/public/---dgreports/---stat/documents/normativeinstrument/wcms_087562.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Paris Agreement",
    definition: (
      <>
        The Paris Agreement is an agreement within the United Nations Framework
        Convention on Climate Change, dealing with greenhouse-gas-emissions
        mitigation, adaptation, and finance, signed in 2016.
        <br />
        <br />
        <em>Source:</em> “What Is the Paris Agreement?” UNFCCC.{" "}
        <a
          href="https://unfccc.int/process-and-meetings/the-paris-agreement/what-is-the-paris-agreement"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Partnership",
    definition: (
      <>
        An organization that is owned by two or more individuals or other
        entities and is controlled by those partners.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Internal Revenue Service{" "}
        <a
          href="http://www.irs.gov/Businesses/Partnerships"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Part-Time Employee",
    definition: (
      <>
        Part-time paid employees work year round but do not meet full-time
        equivalency standards (typically less than 35 hours a week).
      </>
    ),
  },
  {
    term: "Peatland",
    definition: (
      <>
        A peatland is an area with or without vegetation with a naturally
        accumulated peat layer at the surface. Peat is sedentarily accumulated
        material consisting of at least 30% (dry mass) of dead organic material.
        <br />
        <br />
        <em>Source:</em> “What is Peat?” International Peatland Society.
        Accessed May 2019.{" "}
        <a
          href="http://www.peatsociety.org/peatlands-and-peat/what-peat"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Peer-to-Peer (P2P)",
    definition: (
      <>
        Organization operates by matching client individuals who have a service
        to offer, to other client individuals who could use that service.
      </>
    ),
  },
  {
    term: "People of Color",
    definition: (
      <>
        Often the preferred collective term for referring to non-white racial
        groups, particularly in the United States (though the term is used
        elsewhere as well). Racial justice advocates have been using the term
        “people of color” since the late 1970s as an inclusive and unifying
        frame across different racial groups that are not white, to address
        racial inequities.
        <br />
        <br />
        While “people of color” can be a politically useful term and describes
        people with their own attributes (as opposed to what they are not, e.g.,
        “non-white”), it is also important whenever possible to identify people
        through their own racial/ethnic group, as each has its own distinct
        experience and meaning and may be more appropriate.
        <br />
        <br />
        In some geographies, “people of color” may be a less apt term than
        “historically disadvantaged,” “previously excluded,” or “minority
        groups.”
        <br />
        <br />
        <em>Source:</em> “Race Reporting Guide.” Race Forward, March 20, 2017.{" "}
        <a
          href="https://www.raceforward.org/reporting-guide"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        See also the IRIS+ definitions on White Supremacy, Racial and ethnic
        identity, and Race.
      </>
    ),
  },
  {
    term: "Perennial Snow or Ice",
    definition: (
      <>
        Land with perennial snow cover, including perennial snowfields, and
        glaciers.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Peri-Urban",
    definition: (
      <>
        The areas immediately adjoining urban areas. Such areas are found
        outside formal urban boundaries and urban jurisdictions which are in a
        process of urbanization and which therefore progressively assume many of
        the characteristics of urban areas. Inhabitants in these areas generally
        fall into the low-income group of the community and mostly live in
        slums. These peri-urban areas are also seen as an interface between the
        urban and rural areas.
        <br />
        <br />
        <em>Source:</em> Adapted from the United Nations Food and Agriculture
        Organization{" "}
        <a
          href="http://www.fao.org/faoterm/viewentry/en/?entryId=100740"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Permanence",
    definition: (
      <>
        The risk that the carbon sequestered through the project would be
        reversed back into the atmosphere over time
        <br />
        <br />
        <em>Source:</em> Verra. VCS: Agriculture, Forestry and Other Land Use
        (AFOLU) Requirements. Washington, DC: Verra, June 2017.
      </>
    ),
  },
  {
    term: "Permanently Protected Land",
    definition: (
      <>
        Protected land for which legal land use restrictions set for the
        purposes of maintaining biological diversity and natural resources are
        permanent and established in perpetuity. Being established in perpetuity
        means that the deed of conservation easement must state that the
        restriction remains on the property forever and is binding on current
        and future owners of the property. See definition for "Protected Land."
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Internal Revenue Service{" "}
        <a
          href="http://www.gpo.gov/fdsys/pkg/CFR-2000-title26-vol3/pdf/CFR-2000-title26-vol3-sec1-170A-14.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Pesticides",
    definition: (
      <>
        Pesticides refers to insecticides, fungicides, herbicides,
        disinfectants, and any substance intended for preventing, destroying,
        attracting, repelling, or controlling any pest, including unwanted
        species of plants or animals during the production, storage, transport,
        distribution, and processing of food, agricultural commodities, or
        animal feeds that may be administered to animals for the control of
        parasites.
        <br />
        <br />
        Organizations that use pesticides with varying levels of hazard can
        refer to the following source for further information on recommended
        classifications of pesticides by hazard level: The WHO Recommended
        Classification of Pesticides by Hazard{" "}
        <a
          href="http://www.who.int/ipcs/publications/pesticides_hazard/en/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        <br />
        <em>Sources:</em> United Nations Food and Agriculture Organization
        (FAO), World Health Organization (WHO)
      </>
    ),
  },
  {
    term: "Phytochemicals",
    definition: (
      <>
        Phytochemicals are substances found in plants that may contribute to
        health promoting effects within the human body.
        <br />
        <br />
        <em>Source:</em> Claus, Leitzmann. “Characteristics and Health Benefits
        of Phytochemicals.” National Center for Biotechnology Information. U.S.
        National Library of Medicine, February 2016.{" "}
        <a
          href="https://pubmed.ncbi.nlm.nih.gov/27160996/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Platform Economy",
    definition: (
      <>
        The use of digital labor platforms where work is outsourced through
        either crowdwork (an open call to a geographically dispersed crowd) or
        location-based (usually via apps that allocate work to individuals,
        typically to perform local, service-oriented tasks such as driving or
        running errands). Often used as a synonym for the gig economy.
        <br />
        <br />
        <em>Source:</em> "Job Quality in the Platform Economy." ILO, Global
        Commission on the Future of Work, 2018.{" "}
        <a
          href="https://www.ilo.org/wcmsp5/groups/public/---dgreports/---cabinet/documents/publication/wcms_618167.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Point of Care",
    definition: (
      <>
        The time and place of patient care when a healthcare professional
        delivers products and services. Point of care assumes that test results
        will be available instantly or in a very short time frame to assist
        caregivers with immediate diagnosis and/or clinical intervention.
        <br />
        <br />
        <em>Source:</em> The Navigating Impact project
      </>
    ),
  },
  {
    term: "Poor",
    definition: (
      <>
        The poor are people living below a recognized poverty line.
        Organizations should clearly footnote the poverty thresholds used and
        the sources referenced. Commonly recognized poverty lines include (1)
        persons living below the poverty line established by the national
        government, or (2) persons living on less than US $3.10 per day in daily
        per capita expenditures at 2011 Purchasing Power Parity (PPP).*
        <br />
        <br />
        Commonly used tools to help determine the absolute poverty level of
        individuals include:
        <br />- Progress Out of Poverty Index (PPI)
        <br />- USAID Poverty Assessment Tool
        <br />- FINCA Client Assessment Tool (FCAT)
        <br />
        <br />
        As many poverty estimation tools require sampling or other estimation
        techniques, organizations that rely on assumptions should footnote
        details used in the calculation process.
        <br />
        <br />
        *Sourced from The World Bank{" "}
        <a
          href="http://data.worldbank.org/topic/poverty"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        and their World Development Indicators{" "}
        <a
          href="http://data.worldbank.org/data-catalog/world-development-indicators"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
      </>
    ),
  },
  {
    term: "Potable Water",
    definition: (
      <>
        Safe enough to be consumed by humans or used with low risk of immediate
        or long-term harm. Potable water can be used for domestic purposes,
        drinking, cooking, and personal hygiene.
        <br />
        <br />
        <em>Source:</em> Adapted from the World Health Organization{" "}
        <a
          href="http://www.who.int/water_sanitation_health/dwq/gdwq0506.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Privilege",
    definition: (
      <>
        A special right, advantage, or immunity granted or available only to a
        particular person or group.
        <br />
        <br />
        <em>Source:</em> Criterion Institute{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Protected Area",
    definition: (
      <>
        A protected area is a clearly defined geographical space, recognized,
        dedicated and managed, through legal or other effective means, to
        achieve the long term conservation of nature with associated ecosystem
        services and cultural values. (IUCN Definition 2008)
        <br />
        <br />
        <em>Source:</em> International Union for the Conservation of Nature
        (IUCN)
      </>
    ),
  },
  {
    term: "Protected Land",
    definition: (
      <>
        An area of land especially dedicated to the protection and maintenance
        of conservation values and managed through an enforceable legal
        mechanism.
        <br />
        <br />
        Legal restrictions protecting land may be permanent or nonpermanent. See
        permanently protected land.
        <br />
        <br />
        <em>Source:</em> Adapted from the International Union for the
        Conservation of Nature (IUCN){" "}
        <a
          href="https://www.iucn.org/theme/protected-areas/about/protected-areas-categories/category-v-protected-landscapeseascape"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Provisioning Values/Services",
    definition: (
      <>
        Provisioning Values/Services are the goods or products that are obtained
        from ecosystems.
        <br />- Food: Includes crops, livestock, capture fisheries, aquaculture,
        and wild foods
        <br />- Biological raw materials: Includes timber and other wood
        products, fibers and resins, animal skins, sand, and ornamental
        resources
        <br />- Biomass fuel: Biological material derived from living or
        recently living organisms—both plant and animal—that serves as a source
        of energy
        <br />- Freshwater: Inland bodies of water, groundwater, rainwater, and
        surface waters for household, industrial, and agricultural uses
        <br />- Genetic resources: Genes and genetic information used for animal
        breeding, plant improvement, and biotechnology
        <br />- Biochemicals, natural medicines, pharmaceuticals: Medicines,
        biocides, food additives, and other biological materials derived from
        ecosystems for commercial or domestic use
        <br />
        <br />
        <em>Source:</em> World Resources Institute{" "}
        <a
          href="http://pdf.wri.org/corporate_ecosystem_services_review.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Public Toilet",
    definition: (
      <>
        Toilet available to the public (for free or for a fee), including those
        in schools and marketplaces.
      </>
    ),
  },
  {
    term: "Qualified Conservation Organization",
    definition: (
      <>
        An organization is qualified if it is a government entity or a publicly
        recognized charity or social purpose organization. The organization must
        be committed to ensuring the conservation purpose of the land. For
        example, qualified conservation organizations will generally have an
        established monitoring program such as annual property inspections to
        ensure compliance with the conservation goals or terms of the legal
        encumbrances on the land. The organization must also have the resources
        to enforce the restrictions of the conservation easement. Resources do
        not necessarily mean cash. Resources may be in the form of volunteer
        services such as lawyers who provide legal services or people who
        inspect and prepare monitoring reports.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Internal Revenue Service{" "}
        <a
          href="http://www.gpo.gov/fdsys/pkg/CFR-2000-title26-vol3/pdf/CFR-2000-title26-vol3-sec1-170A-14.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Quality Assurance Mechanisms",
    definition: (
      <>
        Peer review/supervision: formal quality performance assessment of staff,
        either through peer review mechanisms or supervision. Assessments often
        focus on documentation and record keeping. Emphasizing outcomes
        measurement and providing structured assessment criteria and forms
        improve the reliability of these mechanisms.
        <br />
        <br />
        Audit and feedback: involves assessing how well staff are meeting
        accepted guidelines or standard practice, often by reviewing patients'
        charts or other documentation. The most common types of audit and
        feedback systems are (a) clinical error tracking, (b) guideline
        adherence monitoring, and (c) stocking and storage monitoring.
        <br />
        <br />
        Checklists and logs: checklists, prompts, and log sheets are common
        tools for quality assurance in healthcare. Common examples are safety
        checklists for surgery and equipment maintenance logs.
        <br />
        <br />
        Electronic monitoring systems: these systems collect and organize
        patient health and organizational performance data. They can be used to
        track patient outcomes, client flows, and manage equipment utilization.
        <br />
        <br />
        Communication and education: structured learning and a focus on
        communication, human factors, and systematized ways of interacting. The
        most common techniques include classroom or small group-based training
        methods, conducting practical activities, and work based learning.
        Communication and education programs can target staff or patients.
        <br />
        <br />
        Guidelines, protocols, and registries: these tools help provide more
        integrated, continuous, and evidence-based care. They provide
        recommendations and instructions for patient management and care.
      </>
    ),
  },
  {
    term: "Race",
    definition: (
      <>
        Race is a made-up social construct, and not an actual biological fact.
        <br />
        <br />
        Race designations have changed over time. Some groups that are
        considered “white” in the United States today were considered
        “non-white” in previous eras, in U.S. Census data and in mass media and
        popular culture (for example, Irish, Italian, and Jewish people). The
        same is true in other countries and contexts.
        <br />
        <br />
        The way in which racial categorizations are enforced (the shape of
        racism) has also changed over time. For example, the racial designation
        of Asian American and Pacific Islander changed four times in the 19th
        century. That is, they were defined at times as white and at other times
        as not white. Asian Americans and Pacific Islanders, as designated
        groups, have been used by whites at different times in history to
        compete with African American labor.
        <br />
        <br />
        <em>SOURCE:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing PBS, “Race: The Power of an Illusion” (2018–2019 relaunch of 2003
        series) and Paul Kivel, Uprooting Racism: How White People Can Work for
        Racial Justice (2002), page 141.
      </>
    ),
  },
  {
    term: "Racial and Ethnic Identity",
    definition: (
      <>
        An individual's awareness and experience of being a member of a racial
        and ethnic group; the racial and ethnic categories that an individual
        chooses to describe them/her/himself based on such factors as biological
        heritage, physical appearance, cultural affiliation, early
        socialization, and personal experience.
        <br />
        <br />
        <em>Source:</em> “Racial Equity Tools - Glossary.” Racial Equity Tools,
        n.d.{" "}
        <a
          href="http://archive.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Racial Equity",
    definition: (
      <>
        Racial equity is the condition that would be achieved if one's racial
        identity no longer predicted, in a statistical sense, how one fares.
        When we use the term, we are thinking about racial equity as one part of
        racial justice, and thus we also include work to address root causes of
        inequities, not just their manifestation. This includes elimination of
        policies, practices, attitudes, and cultural messages that reinforce
        differential outcomes by race or that fail to eliminate them.
        <br />
        <br />
        <em>Source:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing Center for Assessment and Policy Development.
      </>
    ),
  },
  {
    term: "Racial Justice",
    definition: (
      <>
        Racial justice is the systematic fair treatment of people of all races,
        resulting in equitable opportunities and outcomes for all. Racial
        justice—or racial equity—goes beyond “anti-racism.” It is not just the
        absence of discrimination and inequities, but also the presence of
        deliberate systems and supports to achieve and sustain racial equity
        through proactive and preventative measures.
        <br />
        <br />
        Operationalizing racial justice means reimagining and co-creating a just
        and liberated world and includes:
        <br />• understanding the history of racism and the system of white
        supremacy and addressing past harms,
        <br />• working in right relationship and accountability in an ecosystem
        (an issue, sector, or community ecosystem) for collective change,
        <br />• implementing interventions that use an intersectional analysis
        and that impact multiple systems,
        <br />• centering Blackness and building community, cultural, economic,
        and political power of Black, Indigenous, and other People of Color
        (BIPOC), and
        <br />• applying the practice of love along with disruption and
        resistance to the status quo.
        <br />
        <br />
        In IRIS+, “justice” is used as a shorthand for equitable outcomes for
        historically marginalized groups.
        <br />
        <br />
        <em>Source:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing Race Forward, “Race Reporting Guide” (2015), Maggie Potapchuk,
        “Operationalizing Racial Justice in Non-Profit Organizations” (2020),
        and Rinku Sen and Lori Villarosa, “Grantmaking with a Racial Justice
        Lens: A Practical Guide” (2019).
      </>
    ),
  },
  {
    term: "Racism",
    definition: (
      <>
        Racism can be defined as race prejudice and social and institutional
        power, a system of advantage based on race, a system of oppression based
        on race, and a white supremacy system.
        <br />
        <br />
        Racism is different from racial prejudice, hatred, or discrimination.
        Racism involves one group having the power to carry out systematic
        discrimination through the institutional policies and practices of the
        society and by shaping the cultural beliefs and values that support
        those racist policies and practices.
        <br />
        <br />
        <em>Source:</em> Racial Equity Tools Glossary{" "}
        <a
          href="https://www.racialequitytools.org/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        citing “What Is Racism?” − Dismantling Racism Works (dRworks) web
        workbook.
      </>
    ),
  },
  {
    term: "Rangeland",
    definition: (
      <>
        Rangeland historically has been defined as land where the potential
        natural vegetation is predominantly grasses, grasslike plants, forbs, or
        shrubs, and where natural herbivory was an important influence in its
        pre-civilization state. Management techniques which associate soil,
        water, and forage-vegetation resources are more suitable for rangeland
        management than are practices generally used in managing pastureland.
        Some rangelands have been or may be seeded to introduced or domesticated
        plant species. Rangeland subcategories identified in the Anderson Land
        Classification system include: herbaceous range, shrub and brush
        rangeland, and mixed rangeland.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Recalls",
    definition: (
      <>
        Recalls are actions taken by the organization to remove a product from
        the market. Recalls may be conducted on an organization's own
        initiative, by a regulatory body's request, or by a regulatory body's
        order under statutory authority.
      </>
    ),
  },
  {
    term: "Recycled Materials",
    definition: (
      <>
        Materials that comprise of processed recovered waste. Recycled materials
        may include glass, paper, metal, plastic, textiles, and electronics.
        Composted or other processed biodegradable waste is also considered
        recycled material.
        <br />
        <br />
        <em>Source:</em> United States Environmental Protection Agency{" "}
        <a
          href="http://www2.epa.gov/smm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Recycled Water",
    definition: (
      <>
        Recycled Water is treated waste water that is used for beneficial
        purposes (e.g., previously used and treated water to be used for
        irrigation, toilet water, etc.).
        <br />
        <br />
        <em>Source:</em> World Resources Institute{" "}
        <a
          href="http://www.wri.org/sites/default/files/india_water_tool.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Recycling",
    definition: (
      <>
        The reprocessing of materials into new products, which generally
        prevents the waste of potentially useful materials, reduces the
        consumption of raw materials, lowers energy usage, and decreases
        greenhouse gas emissions compared to virgin production.
        <br />
        <br />
        <em>Source:</em> Adapted from the Organization for Economic Cooperation
        and Development{" "}
        <a
          href="https://stats.oecd.org/glossary/detail.asp?ID=2260"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Reducing Emissions from Deforestation and Forest Degradation (REDD)",
    definition: (
      <>
        REDD, now known by its full title as “Reducing emissions from
        deforestation and forest degradation and the role of conservation,
        sustainable management of forests and enhancement of forest carbon
        stocks in developing countries (REDD+),” is a United Nations program to
        reduce net emissions of greenhouse gases from forests.
      </>
    ),
  },
  {
    term: "Reforestation",
    definition: (
      <>
        Planting of forests on lands that have previously contained forest but
        have since been converted to some other use. Reforestation is a natural
        climate solution in which the carbon sequestration is determined by the
        area converted to forest land.
        <br />
        <br />
        <em>Sources:</em> Griscom, Bronson W., et al. “Natural Climate
        Solutions.” Proceedings of the National Academy of Sciences 114, no. 44
        (October 31, 2017): 11645–650.
        <br />
        Intergovernmental Panel on Climate Change (IPCC){" "}
        <a
          href="https://www.ipcc.ch/site/assets/uploads/2018/02/ar4-wg3-chapter9-1.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Regulating Values/Services",
    definition: (
      <>
        [Note: The original text appears to have a copy-paste error repeating
        the reforestation definition. Assuming this refers to regulating
        ecosystem services such as regulation of floods, drought, land
        degradation, and disease — as commonly defined in ecosystem services
        frameworks. If this is incorrect, please clarify.]
      </>
    ),
  },
  {
    term: "Remittances",
    definition: (
      <>
        Cross-border, person-to-person payments of a relative low value.
        Typically, a private flow of funds between family members.
        <br />
        <br />
        <em>Source:</em> IFAD{" "}
        <a
          href="https://www.ifad.org/documents/38714170/40187309/gpfi.pdf/58ce7a06-7ec0-42e8-82dc-c069227edb79"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Renewable Energy",
    definition: (
      <>
        Renewable energy sources are those derived from natural processes that
        are capable of being replenished in a short time through ecological
        cycles. These sources have the benefit of being abundant, available in
        some capacity nearly everywhere, and they cause little if any
        environmental damage. Renewable energy sources include: Geothermal,
        Wind, Solar, Hydro, and Biomass. They also include electricity and heat
        generated from ocean, hydropower, biofuels, and hydrogen derived from
        renewable resources.
        <br />
        <br />
        <em>Source:</em> Adapted from the Global Reporting Initiative{" "}
        <a
          href="https://g4.globalreporting.org/introduction/glossary/pages/default.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Repetition Rate",
    definition: (
      <>
        Number of students repeating a given grade in a given school year,
        expressed as a percentage of enrollment in that grade the previous
        school year.
        <br />
        <br />
        <em>Source:</em> UNESCO
      </>
    ),
  },
  {
    term: "Reporting Period",
    definition: (
      <>
        The reporting period is the time from the Report Start Date (OD6951) to
        the Report End Date (OD7111).
      </>
    ),
  },
  {
    term: "Resilience",
    definition: (
      <>
        The ability of a system and its component parts to anticipate, absorb,
        accommodate, or recover from the effects of a hazardous event in a
        timely and efficient manner, including through ensuring the
        preservation, restoration, or improvement of its essential basic
        structures and functions.
        <br />
        <br />
        <em>Source:</em> Field, C.B. et al. “Managing the Risks of Extreme
        Events and Disasters to Advance Climate Change Adaptation.” IPCC, 2012.
      </>
    ),
  },
  {
    term: "Responsible Finance",
    definition: (
      <>
        Responsible finance refers to offering financial services in an
        accountable, transparent, respectful, and ethical manner. The
        responsible finance movement in the inclusive finance sector consists of
        a series of well-coordinated initiatives to enhance client protection,
        strengthen social performance management, and define acceptable behavior
        for investors and donors. The most important of these are the Smart
        Campaign (Client Protection Principles) and the Social Performance Task
        Force (Universal Standards for Social Performance Management)
        <br />
        <br />
        <em>Source:</em> The Navigating Impact project
      </>
    ),
  },
  {
    term: "Responsive Care",
    definition: (
      <>
        Responsive care is the process of watching and tuning into your child’s
        cues, thinking about what they might mean, and then responding to them
        in a sensitive way. For more on this topic, see the Center for Child
        Development at Harvard University's resources on relationships and serve
        and return{" "}
        <a
          href="https://developingchild.harvard.edu/science/key-concepts/serve-and-return/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
        <br />
        <br />
        <em>Source:</em> “Responsive Care.” ZERO TO THREE, February 2015{" "}
        <a
          href="https://www.zerotothree.org/resources/212-responsive-care"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Revenue",
    definition: (
      <>
        Revenue is the gross inflow of economic benefits arising in the course
        of the ordinary activities of an organization when those inflows result
        in increases in equity, excluding increases relating to contributions
        from equity participants. Revenue includes only the gross inflows of
        monies received and receivable by the organization on its own account.
        Amounts collected on behalf of third parties, such as sales taxes, goods
        and services taxes, and value added taxes are not economic benefits
        which flow to the entity and do not result in increases in equity.
        Therefore, they are excluded from revenue. Similarly, in an agency
        relationship, the gross inflows of economic benefits include amounts
        collected on behalf of the principal and do not result in increases in
        equity for the entity. The amounts collected on behalf of the principal
        are not revenue. Instead, revenue is the amount of commission.
        <br />
        <br />
        <em>Source:</em> Alexander, David, Anne Britton, and Ann Jorissen.
        International Financial Reporting and Analysis. 3rd ed. London: Thomson
        Learning, 2007. 417. Google Books. Web.
      </>
    ),
  },
  {
    term: "Rotation",
    definition: (
      <>
        In forestry, rotation is the time elapsed from planting to harvesting.
        <br />
        <br />
        <em>Source:</em> "What We Do.” Ecotrust Forest Management. Accessed
        April 2019.{" "}
        <a
          href="https://efmi.com/management-approach/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Rough Sleep",
    definition: (
      <>
        To sleep or bed down in the open air (such as on the streets or in
        doorways, parks, or bus shelters) or in buildings or other places not
        designed for habitation (such as barns, sheds, car parks, cars, derelict
        boats, stations, or 'bashes').
        <br />
        <br />
        <em>Source:</em> Who, What, Why: How Do You Count Rough Sleepers?{" "}
        <a
          href="https://www.bbc.com/news/magazine-10929761"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Ruminant",
    definition: (
      <>
        An even-toed ungulate mammal that chews the cud regurgitated from its
        rumen. The ruminants comprise the cattle, sheep, antelopes, deer,
        giraffes, and their relatives.
        <br />
        <br />
        <em>Source:</em> “Ruminant: Definition of Ruminant by Oxford Dictionary
        on Lexico.com.” Lexico Dictionaries.{" "}
        <a
          href="https://www.lexico.com/en/definition/ruminant"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Rural",
    definition: (
      <>
        Rural areas are those not characterized as peri-urban or urban. The
        traditional distinction between urban and rural areas within a country
        has been based on the assumption that urban areas, no matter how they
        are defined, provide a different way of life and usually a higher level
        of living than are found in rural areas. In many industrialized
        countries, this distinction has become blurred and the principal
        difference between urban and rural areas in terms of the circumstances
        of living tends to be a matter of the degree of concentration of
        population. Although the differences between urban and rural ways of
        life and standards of living remain significant in developing countries,
        rapid urbanization in these countries has created a great need for
        information related to different sizes of urban areas. This is when
        classification by size of locality can usefully supplement the
        urban-rural dichotomy or even replace it depending on the circumstances
        in the country.
        <br />
        <br />
        <em>Source:</em> United Nations Statistical Commission, Principles and
        Recommendations for a Vital Statistics System, 2013{" "}
        <a
          href="http://unstats.un.org/unsd/demographic/sconcerns/densurb/densurbmethods.htm#B"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Rural Finance",
    definition: (
      <>
        Provision of financial services in rural areas that support a wide range
        of economic activities and households of various income levels.
        <br />
        <br />
        <em>Source:</em> ILO{" "}
        <a
          href="https://www.ilo.org/public/libdoc/ilo/2012/112B09_41_engl.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Safely Managed Drinking Water",
    definition: (
      <>
        An improved drinking water source that is located on premises, available
        when needed, and free from fecal and priority chemical contamination.
        <br />
        <br />
        <em>Source:</em> SDG Tracker. “Sustainable Development Goal 6: Ensure
        Access to Water and Sanitation For All.”{" "}
        <a
          href="https://sdg-tracker.org/water-and-sanitation"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Safely Managed Sanitation",
    definition: (
      <>
        Sanitation facilities which are not shared with other households and
        ensure the hygienic separation of human excreta from human contact,
        treated either on- or off-site.
        <br />
        <br />
        <em>Source:</em> World Health Organization. “Sanitation.” Fact sheet,
        June 14, 2019.{" "}
        <a
          href="https://www.who.int/en/news-room/fact-sheets/detail/sanitation"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Salaried",
    definition: (
      <>
        Employees who are paid on a fixed basis, receiving a predetermined
        amount (as defined in a contract, for example) that is not subject to
        deductions for the quality or quantity of work. Salaried employees'
        earnings are not contingent on the amount of time worked and are
        typically paid for a defined term (e.g., yearly).
      </>
    ),
  },
  {
    term: "Science-Based Targets",
    definition: (
      <>
        Science-based targets are a set of goals developed by a business to
        provide it with a clear route to reduce greenhouse gas emissions. An
        emissions reduction target is defined as 'science-based' if it is
        developed in line with the scale of reductions required to keep global
        warming below 2C from pre-industrial levels.
        <br />
        <br />
        <em>Source:</em> “What Is a Science-Based Target?” Science Based
        Targets.{" "}
        <a
          href="https://sciencebasedtargets.org/what-is-a-science-based-target/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sensitivity",
    definition: (
      <>
        The degree to which a system is affected or influenced by climate
        hazards. Sensitivity depends on factors such as socio-economic
        conditions, infrastructure quality, natural resource dependence, and
        demographic characteristics.
        <br />
        <br />
        <em>Source:</em> U.S. Climate Resilience Toolkit.{" "}
        <a
          href="https://toolkit.climate.gov/content/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sex",
    definition: (
      <>
        Sex refers to the biology of an individual with specific reference to
        their chromosomal, hormonal and anatomical characteristics that are used
        to classify them as female, male, or intersex at birth.
        <br />
        <br />
        <em>Source:</em> Criterion Institute{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sexual Harassment",
    definition: (
      <>
        Unwelcome sexual advances or verbal or physical conduct of a sexual
        nature which has the purpose or effect of unreasonably interfering with
        the individual's work performance or creating an intimidating, hostile,
        abusive, or offensive working environment.
        <br />
        <br />
        Behavior that qualifies as sexual harassment includes the following:
        <br />- Physical: Physical violence; touching; unnecessary close
        proximity
        <br />- Verbal: Comments and questions about appearance, life-style,
        sexual orientation; offensive phone calls
        <br />- Non-verbal: Whistling; sexually-suggestive gestures; display of
        sexual materials
        <br />
        <br />
        <em>Source:</em> International Labor Organization{" "}
        <a
          href="http://www.ilo.org/thesaurus/defaulten.asp"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        (and search "sexual harassment")
      </>
    ),
  },
  {
    term: "Sexual Orientation",
    definition: (
      <>
        Sexual orientation refers to an individual’s romantic and/or sexual
        attraction to another person. It includes but is not limited to:
        asexual, bisexual, gay, lesbian, straight, etc.
        <br />
        <br />
        <em>Source:</em> Criterion Institute{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Shared Toilet",
    definition: (
      <>
        Toilet used by a negotiated group of people, such as a group of
        neighbors.
      </>
    ),
  },
  {
    term: "Shifting Agriculture",
    definition: (
      <>
        A local practice in the tropics where “land is cleared and burned for
        short-term cultivation of subsistence crops.” Often this land is left to
        regenerate after harvesting.
        <br />
        <br />
        <em>Source:</em> Curtis, Philip G., et al. “Classifying Drivers of
        Global Forest Loss.” Science 361, no. 6407 (September 2018): 1108–11.
      </>
    ),
  },
  {
    term: "Silviculture",
    definition: (
      <>
        The art and science of controlling the establishment, growth,
        composition, health, and quality of forests and woodlands to meet the
        diverse needs and values of landowners and society such as wildlife
        habitat, timber, water resources, restoration, and recreation on a
        sustainable basis.
        <br />
        <br />
        <em>Source:</em> “Silviculture.” U.S. Forest Service. Accessed May 2019.{" "}
        <a
          href="https://www.fs.fed.us/forestmanagement/vegetation-management/silviculture/index.shtml"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Skills",
    definition: (
      <>
        The innate or learned ability to apply knowledge acquired through
        experience, study, practice, or instruction, and to perform tasks and
        duties required by a given job. Skills may be: (1) job-specific or
        technical skills, (2) basic skills (literacy and numeracy), or (3)
        generic, transversal, soft, or portable skills.
        <br />
        <br />
        <em>Source:</em> "Qualification and Skill Mismatch: Concepts and
        Measurement." ILO, 2017.{" "}
        <a
          href="https://www.ilo.org/skills/pubs/WCMS_554348/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Skills Mismatch",
    definition: (
      <>
        A discrepancy between the skills that are sought by employers and the
        skills that are possessed by individuals. This means that education and
        training are not providing the skills demanded in the labor market, or
        that the economy does not create jobs that correspond to the skills of
        individuals.
        <br />
        <br />
        <em>SOURCE:</em> "What is Skills Mismatch and Why Should We Care?" ILO,
        2020.{" "}
        <a
          href="https://www.ilo.org/skills/Whatsnew/WCMS_740388/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Small and Medium Enterprises (SMEs)",
    definition: (
      <>
        Small and medium-sized enterprises (SMEs) are non-subsidiary,
        independent firms which employ fewer than a given number of employees.
        This number varies across countries. The most frequent upper limit
        designating an SME is 250 employees, as in the European Union. However,
        some countries set the limit at 200 employees, while the United States
        considers SMEs to include firms with fewer than 500 employees.
        <br />
        <br />
        Small firms are generally those with fewer than 50 employees, while
        micro-enterprises have at most 10, or in some cases 5, workers.
        <br />
        <br />
        Financial assets are also used to define SMEs. In the European Union, a
        new definition came into force on 1 January 2005 applying to all
        Community acts and funding programmes as well as in the field of State
        aid where SMEs can be granted higher intensity of national and regional
        aid than large companies. The new definition provides for an increase in
        the financial ceilings: the turnover of medium-sized enterprises (50-249
        employees) should not exceed EUR 50 million; that of small enterprises
        (10-49 employees) should not exceed EUR 10 million while that of micro
        firms (less than 10 employees) should not exceed EUR 2 million.
        Alternatively, balance sheets for medium, small and micro enterprises
        should not exceed EUR 43 million, EUR 10 million and EUR 2 million,
        respectively.
        <br />
        <br />
        <em>Source:</em> OECD glossary
      </>
    ),
  },
  {
    term: "Smallholder Farmers",
    definition: (
      <>
        Smallholder farmers are marginal and sub-marginal farm households
        constrained in size and resources. Some sources define smallholder
        farmers as those who cultivate between 1 hectare to 10 hectares (for
        more semi-arid areas) of land. While they will vary in farm size and
        crop/livestock distribution according to their activity and region,
        common characteristics of smallholder farmers are that they have low
        access to technology, limited resources in terms of capital, skills, and
        risk management, depend on family labor for most activities, and have
        limited capacity in terms of storage, marketing, and processing.
        <br />
        <br />
        Organizations should detail the characteristics of the smallholders they
        reference, including the size of land managed.
        <br />
        <br />
        <em>Source:</em> United Nations Food and Agriculture Organization{" "}
        <a
          href="www.fao.org/fileadmin/templates/nr/sustainability.../Factsheet_SMALLHOLDERS.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Smallholder Forestry",
    definition: (
      <>
        Forestry practiced by smallholders on land that is privately owned.
        <br />
        <br />
        <em>Source:</em> Gilmour, Don. Forty Years of Community-Based Forestry:
        A Review of Its Extent and Effectiveness. FAO Forestry Paper 176. Rome:
        Food and Agriculture Organization of the United Nations: 2016.
      </>
    ),
  },
  {
    term: "Smart Meter",
    definition: (
      <>
        A smart meter is an electronic device that records information such as
        consumption of electric energy, voltage levels, current, and power
        factor. Smart meters communicate the information to the consumer for
        greater clarity of consumption behavior, and electricity suppliers for
        system monitoring and customer billing.
        <br />
        <br />
        <em>Source:</em> McGovern, Hayden. “What Is a Smart Meter?” SmartEnergy,
        December 2016.{" "}
        <a
          href="https://www.smartenergy.com/what-is-a-smart-meter/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Social Determinants of Health",
    definition: (
      <>
        Social determinants of health are conditions in the environments in
        which people are born, live, learn, work, play, worship, and age that
        affect a wide range of health, functioning, and quality-of-life outcomes
        and risks.
        <br />
        <br />
        <em>Source:</em> “Social Determinants of Health.” Social Determinants of
        Health | Healthy People 2020.{" "}
        <a
          href="https://www.healthypeople.gov/2020/topics-objectives/topic/social-determinants-of-health"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Social Performance Management",
    definition: (
      <>
        Social performance management (SPM) refers to the systems that
        organizations use to achieve their stated social goals and put customers
        at the center of strategy and operations. A provider's social
        performance refers to its effectiveness in achieving its stated social
        goals and creating value for clients. If a provider has strong SPM
        practices, it is more likely to achieve strong social performance.
        <br />
        <br />
        <em>Source:</em> Social Performance Task Force{" "}
        <a
          href="https://sptf.info/get-started/what-is-spm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Soil Degradation",
    definition: (
      <>
        Soil degradation is the diminishing capacity of the soil to provide
        ecosystem goods and services as desired by its stakeholders.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Soil Health",
    definition: (
      <>
        Soil health is the continued capacity of the soil to function as a vital
        living system, within ecosystem and land-use boundaries, to sustain
        biological productivity, promote the quality of air and water
        environments, and maintain plant, animal, and human health.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Soil Organic Carbon (SOC)",
    definition: (
      <>
        Soil organic carbon (SOC) is a summarizing parameter including all of
        the carbon forms for dissolved (DOC: Dissolved Organic Carbon) and total
        organic compounds (TOC: Total Organic Carbon) in soils.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Soil Organic Matter (SOM)",
    definition: (
      <>
        Soil organic matter (SOM) is matter consisting of plant and/or animal
        organic materials, and the conversion products of those materials in
        soils.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Soil Salinization",
    definition: (
      <>
        Soil salinization is defined as the increase in water-soluble salts in
        soil which is responsible for increasing the osmotic pressure of the
        soil. In turn, this negatively affects plant growth because less water
        is made available to plants.
        <br />
        <br />
        <em>Source:</em> “Status of the World's Soil Resources. Main Report
        |Policy Support and Governance| Food and Agriculture Organization of the
        United Nations .” Food and Agriculture Organization of the United
        Nations (FAO) and Intergovernmental Technical Panel on Soils (ITPS),
        2015.{" "}
        <a
          href="http://www.fao.org/policy-support/tools-and-publications/resources-details/en/c/435200/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sole-Proprietorship",
    definition: (
      <>
        An organization controlled by an individual owner.
        <br />
        <br />
        <em>Source:</em> Adapted from the United States Internal Revenue Service{" "}
        <a
          href="http://www.irs.gov/Businesses/Small-Businesses-&-Self-Employed/Sole-Proprietorships"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Solidarity Group Lending",
    definition: (
      <>
        Solidarity Group lending refers to the use of groups for disbursement of
        funds and collection of repayment on loans to either the group as a
        whole or to the individual members of that group. Borrowers of such
        groups often bear joint and several liability for the repayment of all
        loans to the group and its members. This group liability may also
        determine credit decisions made by the institution. Solidarity Groups
        vary in the degrees to which they use groups for credit decisions,
        disbursement, collection, or to reduce credit risk. For IRIS, loans are
        considered to be of the Solidarity Group methodology when some aspect of
        loan consideration depends on the group, including credit analysis,
        liability, guarantee, collateral, and loan size and conditions.
        <br />
        <br />
        <em>Source:</em> Microfinance Information Exchange{" "}
        <a
          href="http://www.mixmarket.org/about/faqs/glossary"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Stakeholder",
    definition: (
      <>
        A person with an interest or concern in something, especially a
        business. Stakeholders may include customers, clients, users, end users,
        constituent, and beneficiaries.
        <br />
        <br />
        <em>Source:</em> The Impact Management Project{" "}
        <a
          href="https://impactmanagementproject.com/glossary/?_sf_s=stakeholder"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "State-Imposed Forced Labor",
    definition: (
      <>
        Includes work exacted by public authorities, military, or paramilitary;
        compulsory participation in public works; and forced prison labor
        <br />
        <br />
        <em>Source:</em> "Global Estimates of Modern Slavery: Forced Labour and
        Forced Marriage." ILO, 2017.{" "}
        <a
          href="https://www.ilo.org/global/publications/books/WCMS_575479/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Stock-Out",
    definition: (
      <>
        A stock-out is a situation in which an item is out of stock (for
        example, when a pharmacy runs out of a certain type of medicine or
        health supply).
        <br />
        <br />
        <em>Source:</em> The Navigating Impact project
      </>
    ),
  },
  {
    term: "Stormwater",
    definition: (
      <>
        Runoff generated from rain and snowmelt events that flow over land or
        impervious surfaces, such as paved streets, parking lots, and building
        rooftops, and does not soak into the ground.
        <br />
        <br />
        <em>Source:</em> Alliance for Water Stewardship. “International Water
        Stewardship Standard, Version 2.0.” Alliance for Water Stewardship,
        North Berwick, Scotland, March 22, 2019.
      </>
    ),
  },
  {
    term: "Strategic Goal",
    definition: (
      <>
        IRIS+ includes common strategic goals deployed by impact investors to
        achieve established social or environmental impact objectives within
        generally accepted impact categories and themes. Strategic goals
        included in IRIS+ have been recognized as common practice and are
        supported by research. They are not exhaustive.
        <br />
        <br />
        <em>Source:</em> IRIS+ Thematic Taxonomy
      </>
    ),
  },
  {
    term: "Streams",
    definition: (
      <>
        A stream refers to a natural flowing body of water. It typically has a
        current and is confined within a bed and stream banks.
        <br />
        <br />
        Organizations can refer to the following sources for further information
        on the definition of a stream:
        <br />
        USGS, Science in Your Watershed{" "}
        <a
          href="http://water.usgs.gov/wsc/glossary.html#Stream"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        EPA, Streams{" "}
        <a
          href="http://water.epa.gov/type/rsl/streams.cfm#resources"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Structural Racism",
    definition: (
      <>
        Refers to the set of practices, cultural norms, and institutional
        arrangements that are reflective of, and help to create and maintain,
        racialized outcomes in society—reinforcing group-based advantages and
        disadvantages.
        <br />
        <br />
        <em>Source:</em> Ayazi, Hossein, and Elsadig Elsheikh. “The U.S. Farm
        Bill: Corporate Power and Structural Racialization in the United States
        Food System (2015).” The U.S. Farm Bill: Corporate Power and Structural
        Racialization in the United States Food System. Haas Institute for a
        Fair and Inclusive Society.{" "}
        <a
          href="https://www.academia.edu/18941323/The_U_S_Farm_Bill_Corporate_Power_and_Structural_Racialization_in_the_United_States_Food_System_2015_"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        See also the IRIS+ definition on White Supremacy.
      </>
    ),
  },
  {
    term: "Student-centered learning",
    definition: (
      <>
        The term student-centered learning refers to a wide variety of
        educational programs, learning experiences, instructional approaches,
        and academic-support strategies that are intended to address the
        distinct learning needs, interests, aspirations, or cultural backgrounds
        of individual students and groups of students. To accomplish this goal,
        schools, teachers, guidance counselors, and other educational
        specialists may employ a wide variety of educational methods, from
        modifying assignments and instructional strategies in the classroom to
        entirely redesigning the ways in which students are grouped and taught
        in a school.
        <br />
        <br />
        <em>Source:</em> The Glossary of Education Reform. "Student-Centered
        Learning."{" "}
        <a
          href="https://www.edglossary.org/student-centered-learning/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Stunting",
    definition: (
      <>
        Stunting is the impaired growth and development that children experience
        from poor nutrition, repeated infection, and inadequate psychosocial
        stimulation. Children are defined as stunted if their height-for-age is
        more than two standard deviations below the WHO Child Growth Standards
        median.
        <br />
        <br />
        <em>Source:</em> World Health Organization. "Stunting in a Nutshell."
      </>
    ),
  },
  {
    term: "Supplier",
    definition: (
      <>
        Business that provides goods or services to an organization to help move
        a product or service from the organization to its customer.
      </>
    ),
  },
  {
    term: "Supporting Values/Services",
    definition: (
      <>
        Supporting Values/Services are the natural processes that maintain the
        other ecosystem services.
        <br />- Habitat: Natural or semi-natural spaces that maintain species
        populations and protect the capacity of ecological communities to
        recover from disturbances
        <br />- Nutrient cycling: Flow of nutrients (e.g., nitrogen, sulfur,
        phosphorus, carbon) through ecosystems
        <br />- Primary production: Formation of biological material by plants
        through photosynthesis and nutrient assimilation
        <br />- Water cycling: Flow of water through ecosystems in its solid,
        liquid, or gaseous forms
        <br />
        <br />
        <em>Source:</em> World Resources Institute{" "}
        <a
          href="http://pdf.wri.org/esr_definitions_of_ecosystem_services.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Supportive Learning Environment",
    definition: (
      <>
        A supportive environment includes physical space, equipment and
        materials, daily structure and planning, as well as positive and engaged
        relationships between adults and children. The environment needs to be
        carefully planned based on knowledge of typical development of children,
        as well as the specific developmental needs of the population. Many
        factors influence children’s learning and behavior. Thus, the
        environment should be thoughtfully designed to be responsive to
        children’s needs, and should provide opportunities for learning and
        growth in all developmental domains and curriculum areas.
        <br />
        <br />
        One critical element of a supportive learning environment is active
        engagement with a parent or caretaker, also known as “serve and return.”
        For more on serve and return, see Harvard University's Center for the
        Developing Child{" "}
        <a
          href="https://developingchild.harvard.edu/science/key-concepts/serve-and-return/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        , and for more on responsive learning environments, see Teacher Time{" "}
        <a
          href="https://eclkc.ohs.acf.hhs.gov/sites/default/files/pdf/teacher-time-preschool-ep-2-viewers-guide.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
        <br />
        <br />
        <em>Sources:</em> State Government of Massachusetts. “Building
        Supportive Learning Environments.”{" "}
        <a
          href="https://www.mass.gov/files/2017-07/building-supportive-environments.docx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Surface Water",
    definition: (
      <>
        Water on the surface of the Earth, such as streams, rivers, lakes,
        wetlands, or oceans.
      </>
    ),
  },
  {
    term: "Sustainable Cultivation",
    definition: (
      <>
        Sustainable cultivation/farming practices commonly include: crop
        rotations that mitigate weeds, disease, insect, and other pest problems,
        provide alternative sources of soil nitrogen, reduce soil erosion, and
        reduce risk of water contamination by agricultural chemicals. Common
        practices also include pest control strategies that are not harmful to
        natural systems, farmers, their neighbors, or consumers. This includes
        integrated pest management techniques that reduce the need for
        pesticides by practices such as: scouting, use of resistant cultivars,
        timing of planting, biological pest controls, increased
        mechanical/biological weed control, more soil and water conservation
        practices, strategic use of animal and green manures, and use of natural
        or synthetic inputs in a way that poses no significant hazard to man,
        animals, or the environment.
        <br />
        <br />
        <em>Source:</em> United States Department of Agriculture Dictionary{" "}
        <a
          href="http://www.nal.usda.gov/afsic/pubs/terms/srb9902.shtml#toc2"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sustainable Forest Management (SFM)",
    definition: (
      <>
        The stewardship and use of forests and forest lands in a way, and at a
        rate, that maintains their biological diversity, productivity,
        regeneration capacity, vitality and their potential to fulfil, now and
        in the future, relevant ecological economic and social functions, at
        local, national and global levels, and that does not cause damage on
        other ecosystems.
        <br />
        <br />
        <em>Source:</em> “Resolution H1: General Guidelines for the Sustainable
        Management of Forests in Europe.” Second Ministerial Conference on the
        Protection of Forests in Europe, Helsinki, Finland, June 16–17, 1993.{" "}
        <a
          href="https://www.foresteurope.org/docs/MC/MC_helsinki_resolutionH1.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Sustainable Stewardship",
    definition: (
      <>
        Sustainable stewardship is a holistic approach intended over the long
        term to: enhance environmental quality and the natural resource base;
        make the most efficient use of nonrenewable resources and integrate,
        where appropriate, natural biological cycles and controls; sustain the
        economic viability of working landscapes; and enhance the quality of
        life for those living and working on the land and society as a whole.
        <br />
        <br />
        Stewardship refers to land management practices as opposed to legal
        restrictions on the use of the land. Economic activities that take place
        on sustainably stewarded land may include sustainable farming, ranching,
        forestry, and recreation. More specifically:
        <br />- Sustainable cultivation: see Sustainable Cultivation.
        <br />- Sustainable forestry: Stewardship and use of forests and forest
        lands that maintains biodiversity, productivity, and regeneration
        capacity and fulfills relevant ecological, economic, and social
        functions. Land use practices typical of sustainable forestry include
        minimal and highly controlled clear cutting, replanting with native
        species, and conservation-oriented management of old growth forests.
        <br />- Sustainable ranching: Ranching practices and use of grazing
        lands that enhance the environmental quality and natural resource base,
        for example, maintaining biodiversity, productivity, and regeneration
        capacity and fulfilling relevant ecological, economic and social
        functions. Sustainable ranching practices include managing grazing
        patterns to reduce surface compaction, water runoff, and maintain
        diverse plant communities, riparian habitat, stream stability, soil
        structure, and nutrient cycles.
        <br />- Sustainable recreation: Hectares open to recreational use,
        including hunting, fishing, hiking, biking, paddling, winter sports, and
        other activities in ways that ensure long term maintenance of
        biodiversity and natural resources. Sustainable recreation management
        practices include educating visitors on appropriate practices to limit
        their impact and identifying carrying capacities for visitors and
        visitor activities such that environmental impacts are within limits of
        acceptable change, which may include limiting the number of visitors,
        planning campsites, and restricting vehicles.
        <br />
        <br />
        <em>Source:</em> IRIS Land Conservation Working Group{" "}
        <a
          href="https://iris.thegiin.org/users/profile/the-david-and-lucile-packard-foundation/documents"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Symbiotic Fungal Networks",
    definition: (
      <>
        Symbiotic fungal networks are closely interacting species within groups
        called modules, that have either parasitic, mutualistic, or
        commensalistic relationships.
        <br />
        <br />
        <em>Source:</em> Toju, Hirokazu, et al. “Assembly of Complex
        Plant–Fungus Networks.” Nature Communications. Nature Publishing Group,
        October 20, 2014.{" "}
        <a
          href="https://www.nature.com/articles/ncomms6273"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Technical and Vocational Education and Training (TVET)",
    definition: (
      <>
        A comprehensive term referring to those aspects of the educational
        process involving deliberate interventions in the study of technologies
        and related sciences to bring about learning that supports the
        acquisition of practical skills, attitudes, understanding, and knowledge
        that make people more productive in designated areas of economic
        activity (e.g., economic sectors, occupations, or specific work tasks).
        <br />
        <br />
        <em>Source:</em> United Nations Educational, Scientific, and Cultural
        Organization (UNESCO) International Centre for Technical and Vocational
        Education and Training{" "}
        <a
          href="https://unevoc.unesco.org/go.php?q=TVETipedia+Glossary+A-Z&filt=all&id=474"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Technology",
    definition: (
      <>
        Tools, systems, knowledge, equipment, machinery, innovative techniques
        etc. that improve quality of life, solve problems, increase productivity
        through application of a scientific methodology.
      </>
    ),
  },
  {
    term: "Temporary Employee",
    definition: (
      <>
        Temporary employees are defined as seasonal and contract employees.
        Seasonal employees are primarily used in agriculture or fisheries.
        Contracted employees are generally hired for the completion of a
        specific task.
        <br />
        <br />
        <em>Source:</em> Adapted from the International Labor Organization{" "}
        <a
          href="http://www.ilo.org/wcmsp5/groups/public/---ed_protect/---protrav/---travail/documents/meetingdocument/wcms_336934.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Tenor of Loan",
    definition: (
      <>
        The length of time until a loan is due.
        <br />
        <br />
        <em>Source:</em> Nasdaq{" "}
        <a
          href="http://www.nasdaq.com/investing/glossary/t/tenor"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Tenure Security",
    definition: (
      <>
        The certainty that a person’s rights to land will be recognized by
        others and protected in cases of specific challenges.
        <br />
        <br />
        <em>Source:</em> Ding, Helen, et al. Climate Benefits, Tenure Costs: The
        Economic Case for Securing Indigenous Land Rights in the Amazon.
        Washington, DC: World Resources Institute, 2016.
      </>
    ),
  },
  {
    term: "Theory of Change",
    definition: (
      <>
        The theory of change (also referred to as the Theory of Value Creation
        or Logic Model) is an expression of the sequence of cause-and-effect
        actions or occurrences by which organizational and financial resources
        are assumed to be converted into the desired social results. It provides
        a conceptual road map for how an organization expects to achieve its
        intended impact and is often displayed in a diagram. A framework built
        around concepts of activities, inputs, outputs, outcomes, and impacts is
        called a logic model or impact value chain.
        <br />
        <br />
        <em>Sources:</em>
        <br />- Global Steering Group for Impact Investment{" "}
        <a
          href="https://gsgii.org/wp-content/uploads/2018/11/GSG-Paper-2018-Widening-Deepening-the-Market-Nov.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Bridgespan{" "}
        <a
          href="http://www.bridgespan.org/Publications-and-Tools/Nonprofit-Management-Tools-and-Trends/Intended-Impact-Theory-of-Change.aspx#.VdcmkflVhHx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Annie E. Casey Foundation{" "}
        <a
          href="http://www.aecf.org/m/resourcedoc/aecf-theoryofchange-2004.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Threatened Species",
    definition: (
      <>
        Threatened species are any species (including animals, plants, fungi,
        etc.) which are likely to become an endangered species within the
        foreseeable future throughout all or a significant portion of its range.
        The term threatened is an umbrella term for a group of categories that
        captures various levels of threat to the species, ranging from
        vulnerable species to endangered species to critically endangered
        species.
        <br />
        <br />
        Organizations can refer to the following sources for further guidance
        and for clarification on the classification definitions cited herein:
        <br />- International Union for the Conservation of Nature{" "}
        <a
          href="https://www.iucnredlist.org/assessment/process"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />- Convention on International Trade in Endangered Species of Wild
        Fauna and Flora{" "}
        <a
          href="https://www.cites.org/eng/disc/how.php"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Tokenism",
    definition: (
      <>
        A minimal or symbolic effort to advance social justice, often associated
        with recruiting a small number of people or single person from
        underrepresented groups to give the appearance of diversity and
        equality.
        <br />
        <br />
        <em>Source:</em> Criterion Institute’s Key Concepts in Gender{" "}
        <a
          href="https://criterioninstitute.org/wp-content/uploads/2019/01/TN2_Key-Concepts.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Toxic Materials",
    definition: (
      <>
        Materials contaminating the environment that cause death, disease, or
        birth defects in the organisms that ingest or absorb them. The
        quantities and the length of exposure necessary to cause these effects
        can vary widely.
        <br />
        <br />
        <em>Source:</em> Organization for Economic Co-operation and Development{" "}
        <a
          href="https://stats.oecd.org/glossary/detail.asp?ID=2735"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Tradable Renewable Energy Certificates",
    definition: (
      <>
        Renewable energy certificates (RECs) represent the environmental
        attributes associated with one megawatt-hour (MWh) of electricity
        production. RECs can be traded, bought and sold separately from
        commodity electricity.
        <br />
        <br />
        <em>Source:</em> “Clean Energy Solutions Center: Tradable Renewable
        Energy Certificates.” Clean Energy Solutions Center | Tradable Renewable
        Energy Certificates.{" "}
        <a
          href="https://cleanenergysolutions.org/instruments/tradable-renewable-energy-certificates"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Transgender",
    definition: (
      <>
        An umbrella term for people whose gender identity and/or expression is
        different from cultural expectations based on the sex they were assigned
        at birth. Being transgender does not imply any specific sexual
        orientation. Therefore, transgender people may identify as straight,
        gay, lesbian, bisexual, etc.
        <br />
        <br />
        <em>Source:</em> Human Rights Campaign{" "}
        <a
          href="https://www.hrc.org/resources/sexual-orientation-and-gender-identity-terminology-and-definitions"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Tundra",
    definition: (
      <>
        Tundra is the term applied to the treeless regions beyond the limit of
        the boreal forest and above the altitudinal limit of trees in high
        mountain ranges. The timber line which separates forest and tundra in
        alpine regions corresponds to an arctic transition zone in which trees
        are increasingly restricted to the most favorable sites. The vegetative
        cover of the tundra is low, dwarfed, and often forms a complete mat.
        These plant characteristics are in large part the result of adaptation
        to the physical environment (one of the most extreme on Earth), where
        temperatures may average above freezing only one or two months out of
        the year, where strong desiccating winds may occur, where great
        variation in solar energy received may exist, and where permafrost is
        encountered almost everywhere beneath the vegetative cover.
        <br />
        <br />
        The Anderson Land Classification System includes the following
        subcategories of Tundra: shrub and brush tundra, herbaceous tundra, bare
        ground tundra, wet tundra, and mixed tundra.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "UN Sustainable Development Goals (SDGs) Regional Groups",
    definition: (
      <>
        Countries, areas and territories are classified into regional groups as
        defined by the UN for the reporting of SDG indicators in 2017. The SDG
        regional groupings are as follows:
        <br />
        Sub-Saharan Africa
        <br />
        North Africa and Western Asia
        <br />
        Central and Southern Asia
        <br />
        Eastern and South-eastern Asia
        <br />
        Latin America and the Caribbean
        <br />
        Australia and New Zealand
        <br />
        Oceania
        <br />
        Europe and North America
        <br />
        <br />
        <em>Source:</em> The Sustainable Development Goals Report 2019
      </>
    ),
  },
  {
    term: "Unbanked",
    definition: (
      <>
        Those who do not have access to the services of a bank or similar
        financial organization.
        <br />
        <br />
        <em>Source:</em> The Navigating Impact project
      </>
    ),
  },
  {
    term: "Underbanked",
    definition: (
      <>
        Those who do not use all the financial services that those with that
        level of income would normally be expected to use.
        <br />
        <br />
        <em>Source:</em> The Navigating Impact project
      </>
    ),
  },
  {
    term: "Upcycling Goods",
    definition: (
      <>
        Upcycling, also known as creative reuse, is the process of transforming
        by-products, waste materials, useless, or unwanted products into new
        materials or products perceived to be of greater quality, such as
        artistic value or environmental value.
        <br />
        <br />
        <em>Source:</em> “What Is Upcycling: A Simple Upcycling Definition
        Around Sustainability.” Youmatter, January 2020.{" "}
        <a
          href="https://youmatter.world/en/definition/upcycling/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Urban",
    definition: (
      <>
        Urban areas are characterized by higher population density and vast
        human features in comparison to areas surrounding it. Use guidelines as
        defined by the area's national government.
        <br />
        <br />
        <em>Source:</em> United Nations Demographic Yearbook{" "}
        <a
          href="http://unstats.un.org/unsd/demographic/sconcerns/densurb/Defintion_of%20Urban.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Urban/Built-up Land",
    definition: (
      <>
        Urban or Built-up Land is comprised of areas of intensive use with much
        of the land covered by structures. Included in this category are cities,
        towns, villages, strip developments along highways, transportation,
        power, communications facilities, areas such as those occupied by mills,
        shopping centers, industrial and commercial complexes, and institutions
        that may, in some instances, be isolated from urban areas.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Utility-Scale Battery Storage",
    definition: (
      <>
        Utility-scale battery storage systems have a typical storage capacity
        ranging from around a few megawatt-hours (MWh) to hundreds of MWh.
        <br />
        <br />
        <em>Source:</em> "IRENA (2019), Innovation landscape brief:
        Utility-scale batteries, International Renewable Energy Agency, Abu
        Dhabi"{" "}
        <a
          href="https://www.irena.org/-/media/Files/IRENA/Agency/Publication/2019/Sep/IRENA_Utility-scale-batteries_2019.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Variable Renewable Energy (VRE)",
    definition: (
      <>
        Renewable energy sources like wind and solar power that are variable in
        terms of output due to their fluctuating nature.
        <br />
        <br />
        <em>Source:</em> IRENA (2019), Innovation landscape brief: Utility-scale
        batteries, International Renewable Energy Agency, Abu Dhabi.{" "}
        <a
          href="https://www.irena.org/-/media/Files/IRENA/Agency/Publication/2019/Sep/IRENA_Utility-scale-batteries_2019.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Very Poor",
    definition: (
      <>
        The very poor are people living below a recognized absolute extreme
        poverty line. Organizations should clearly footnote the poverty
        thresholds used and the sources referenced. Commonly recognized extreme
        poverty lines include (1) persons in the bottom 50% of those living
        below the poverty line established by the national government, (2)
        persons living on less than US $1.90 per day in daily per capita
        expenditures at 2011 Purchasing Power Parity (PPP), and (3) the USAID
        extreme poverty line, which varies by country.*
        <br />
        <br />
        Commonly used tools to help determine the absolute poverty level of
        stakeholders:
        <br />- Progress Out of Poverty Index (PPI)
        <br />- USAID Poverty Assessment Tool
        <br />- FINCA Client Assessment Tool (FCAT)
        <br />
        <br />
        As many poverty estimation tools require sampling or other estimation
        techniques, organizations that rely on assumptions should footnote
        details used in the calculation process.
        <br />
        <br />
        *Sourced from The World Bank{" "}
        <a
          href="http://data.worldbank.org/topic/poverty"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>{" "}
        and their World Development Indicators{" "}
        <a
          href="http://data.worldbank.org/data-catalog/world-development-indicators"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        .
      </>
    ),
  },
  {
    term: "Viability",
    definition: (
      <>
        Economic viability allows for a triple bottom line impact, including an
        array of social and environmental factors. These enterprises tend to be
        the sole, or an important, contributor to the owners’/operators’ family
        income once past the start-up stage, and they must be profitable in
        order to do so. Owners/operators of viable enterprises understand and
        can articulate their mission and vision, know in what direction they
        want to take their businesses, and are successful in meeting their
        goals, even if those goals shift over time with changing markets,
        competition, family situations, etc. This definition does not exclude
        non-profit–owned enterprises. Such enterprises must still cover their
        costs in order to be viable, but the non-profit may bring in funds to
        subsidize educational activities or other mission-based programming that
        complements the farm or food enterprise.
        <br />
        <br />
        <em>Source:</em> “The Blueprint: Building a Business Assistance Network
        for Farm and Food Businesses.” Hudson Valley AgriBusiness Development
        Corporation, the Vermont Farm & Forest Viability Program, The Carrot
        Project, The Joyce and Irving Goldman Family Foundation, The John Merck
        Fund, October 2018.{" "}
        <a
          href="http://www.thecarrotproject.org/yahoo_site_admin/assets/docs/Oct_2018_Blueprint.17110944.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Village/Self-Help Group Lending",
    definition: (
      <>
        Village Banking and Self-Help Groups refer to methodologies that provide
        access to credit and savings services through group or community managed
        associations. Loans from microfinance institutions (MFIs) are considered
        of this type when the MFI lends to the group, which in turn uses this
        money to lend to its members. Loans to the Village Bank or Self-Help
        Group are made under the collective guarantee of the group. Loans may
        also be made from the retained profits of the group or from group
        members' savings. These loans are considered internal to the Village
        Bank or Self-Help Group.
        <br />
        <br />
        <em>Source:</em> Microfinance Information Exchange{" "}
        <a
          href="http://www.themix.org/about-microfinance/glossary-terms"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Voluntary Accounts",
    definition: (
      <>
        Voluntary savings accounts are funds that individuals or organizations
        voluntarily deposit or withdrawal. Voluntary accounts are
        philosophically different than compulsory savings which had been
        introduced as a condition for obtaining a loan and are designed to
        ensure that clients are able to meet their repayments.
        <br />
        <br />
        <em>Source:</em> Adapted from Women's World Banking{" "}
        <a
          href="https://www.microfinancegateway.org/sites/default/files/mfg-en-toolkit-introducing-voluntary-savings-2006_0.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Volunteer",
    definition: (
      <>
        An individual that works for the organization without payment or other
        formal compensation for their time or services.
        <br />
        <br />
        <em>Source:</em> Adapted from International Labor Organization Manual on
        the Measurement of Volunteer Work{" "}
        <a
          href="http://www.ilo.org/global/publications/ilo-bookstore/order-online/books/WCMS_167639/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Vulnerability",
    definition: (
      <>
        Vulnerability is the propensity or predisposition to be adversely
        affected. It is a dynamic concept, varying across temporal and spatial
        scales and depends on economic, social, geographic, demographic,
        cultural, institutional, governance and environmental factors. Measuring
        vulnerability is complex as it needs to be considered across various
        dimensions.
        <br />
        <br />
        <em>Source:</em> “Building Resilience for Adaptation to Climate Change
        in the Agriculture Sector.” Proceedings of a Joint FAO/OECD Workshop,
        April 2012.{" "}
        <a
          href="https://www.irena.org/-/media/Files/IRENA/Agency/Publication/2019/Sep/IRENA_Utility-scale-batteries_2019.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Vulnerable Employment",
    definition: (
      <>
        Refers to the categories of workers who usually do not have job
        security, are not covered by basic protections such as social security
        or social dialogue, or do not have a stable income. Vulnerable workers
        include own-account workers, contributing family workers, and less
        commonly, some employed persons holding paid jobs that lack basic
        criteria for decent jobs.
        <br />
        <br />
        <em>Source:</em> "Paid Employment vs. Vulnerable Employment." ILO, 2018.{" "}
        <a
          href="https://ilo.org/wcmsp5/groups/public/---dgreports/---stat/documents/publication/wcms_631497.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Warranty",
    definition: (
      <>
        A type of guarantee that an organization makes regarding the condition
        of its product or effectiveness of its service. It also refers to the
        terms and situations in which repairs or exchanges will be made in the
        event that the product or service does not function as originally
        described or intended.
        <br />
        <br />
        <em>Source:</em> Adapted from the U.S. Federal Trade Commission{" "}
        <a
          href="http://www.consumer.ftc.gov/articles/0252-warranties"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Wastewater",
    definition: (
      <>
        A combination of one or more of the following:
        <br />- Domestic effluent consisting of blackwater (excreta, urine, and
        fecal sludge) and greywater (kitchen and bathing wastewater)
        <br />- Water from commercial establishments and institutions, including
        hospitals
        <br />- Industrial effluent, stormwater, and other urban run-off
        <br />- Agricultural, horticultural, and aquaculture effluent, either
        dissolved or as suspended matter
        <br />
        <br />
        <em>Source:</em> United Nations Environment Programme{" "}
        <a
          href="https://wedocs.unep.org/bitstream/handle/20.500.11822/8465/-Sanitation,_wastewater_management_and_sustainability_From_waste_disposal_to_resource_recovery-2016sanitation_wastewater_management_and_sustainabilit.pdf?sequence=2&isAllowed=y"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Wastewater Treatment",
    definition: (
      <>
        The process of purifying wastewater, removing contaminants and
        converting it into an effluent that can be discharged with minimum
        impact on the environment, or directly reused. Can be centralized or
        decentralized treatment from both sewerage and on-site sanitation.
        <br />
        <br />
        <em>Source:</em> Science Direct. "Waste Water Treatment."{" "}
        <a
          href="https://www.sciencedirect.com/topics/earth-and-planetary-sciences/waste-water-treatment"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Water Areas",
    definition: (
      <>
        Water areas include streams and canals, lakes, reservoirs, and bays and
        estuaries.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Water Characteristics",
    definition: (
      <>
        Quality of a natural water body in terms of physical, chemical and
        biological parameters. The relevant quality standards are defined by
        national or local regulation and guidelines. Where these are absent,
        then international standards and guidelines should be applied.
        <br />
        <br />
        <em>Source:</em> Connor, Richard, and Koncagül, Engin. The United
        Nations World Water Development Report 2014: Water and Energy. Paris,
        UNESCO, 2014.
      </>
    ),
  },
  {
    term: "Water Conservation",
    definition: (
      <>
        Water conservation refers to efforts made to preserve, control, develop
        water resources, and prevent pollution. This may include reducing the
        total amount of water needed to carry out current processes or tasks but
        does not include overall reduction in water consumption from reduced
        organizational activities (e.g., partial outsourcing of production).
        <br />
        <br />
        Conservation efforts include organizational or technological innovations
        that allow a defined process or task to consume water more efficiently.
        This includes improved water management practices, process redesign, the
        conversion and retrofitting of equipment (e.g., water-efficient
        equipment), or the elimination of unnecessary water use due to changes
        in behavior.
        <br />
        <br />
        <em>Source:</em> Adapted from the Organization for Economic Co-operation
        and Development{" "}
        <a
          href="https://stats.oecd.org/glossary/detail.asp?ID=2903"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Water Scarcity",
    definition: (
      <>
        An imbalance between the supply and demand of freshwater as a result of
        a high level of demand compared to available supply, under prevailing
        institutional arrangements (including price) and infrastructural
        conditions.
        <br />
        <br />
        Physical water scarcity occurs when natural water bodies have
        insufficient water, whether caused by natural conditions (for example,
        in arid regions) or by excessive water abstraction for human use.
        Economic water scarcity occurs when supply to humans is insufficient
        despite water being naturally abundant. This results from
        under-investment in water supply infrastructure, whether due to poverty
        or mismanagement.
        <br />
        <br />
        <em>Sources:</em> OECD. Water Resources Allocation: Sharing Risks and
        Opportunities. OECD Studies on Water. Paris: OECD Publishing, 2015.{" "}
        <a
          href="https://doi.org/10.1787/9789264229631-en"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
        <br />
        Alliance for Water Stewardship. “International Water Stewardship
        Standard, Version 2.0.” Alliance for Water Stewardship, North Berwick,
        Scotland, March 22, 2019.
      </>
    ),
  },
  {
    term: "Water Source",
    definition: (
      <>
        The physical structure from which a water supply is abstracted from a
        water body. For groundwater, it may be a natural spring, a borehole or
        water well. For surface water, it is a ‘water intake.’. It can also
        include the immediate surrounding zone of the main water body, in
        effect, the zone that feeds the point of abstraction. It may apply to
        multiple abstraction points where they are associated, for example, a
        wellfield.
        <br />
        <br />
        <em>Source:</em> Ramsar Convention on Wetlands. Global Wetland Outlook:
        State of the World’s Wetlands and their Services to People. Gland,
        Switzerland: Ramsar Convention Secretariat, 2018.
      </>
    ),
  },
  {
    term: "Water Stress",
    definition: (
      <>
        The baseline water stress is a ratio of the total water withdrawal to
        the freshwater availability in a specific water source.
        <br />
        <br />
        High water stress is defined as a ratio of 40-80% and extremely high is
        defined as a ratio of greater than 80%. High levels of baseline water
        stress indicate that demand for freshwater approaches or exceeds the
        renewable surface freshwater supply, which may lead to greater
        socio-economic competition for freshwater and a higher risk of supply
        disruptions.
        <br />
        <br />
        <em>Source:</em> World Resource Institute{" "}
        <a
          href="https://www.wri.org/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Water Withdrawal",
    definition: (
      <>
        Water drawn from surface water, groundwater, seawater, or a third party
        for any use.
        <br />
        <br />
        <em>Source:</em> GRI Disclosure 303{" "}
        <a
          href="https://www.globalreporting.org/standards/gri-standards-download-center/"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Weather Risk",
    definition: (
      <>
        The potential for severe weather to disrupt business operations or
        damage assets.
        <br />
        <br />
        <em>Source:</em>{" "}
        <a
          href="https://simplicable.com/en/weather-risk"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Wetland",
    definition: (
      <>
        Wetlands are those areas where the water table is at, near, or above the
        land surface for a significant part of most years. The hydrologic regime
        is such that aquatic or hydrophytic vegetation is usually established,
        although alluvial and tidal flats may be nonvegetated. Wetlands are
        frequently associated with topographic lows, even in mountainous
        regions. Examples of wetlands include: marshes, mudflats, and swamps
        situated on the shallow margins of bays, lakes, ponds, streams, and
        manmade impoundments such as reservoirs. They also include wet meadows
        or perched bogs in high mountain valleys and seasonally wet or flooded
        basins, playas, or potholes with no surface water outflow. Shallow water
        areas where aquatic vegetation is submerged are classified as open water
        and are not included in the Wetland category.
        <br />
        <br />
        Extensive parts of some river flood plains qualify as Wetlands, as do
        regularly flooded irrigation overflow areas. These do not include
        agricultural land where seasonal wetness or short-term flooding may
        provide an important component of the total annual soil moisture
        necessary for crop production. Areas in which soil wetness or flooding
        is so short-lived that no typical wetlands vegetation is developed
        properly belong in other categories.
        <br />
        <br />
        Cultivated wetlands such as the flooded fields associated with rice
        production and developed cranberry bogs are classified as Agricultural
        Land.
        <br />
        <br />
        Uncultivated wetlands from which wild rice, cattails, wood products, and
        so forth are harvested or wetlands grazed by livestock are retained in
        the Wetland category. Wetland areas drained for any purpose belong to
        other land use and land cover categories such as Agricultural Land,
        Rangeland, Forest Land, or Urban or Built-up Land. When the drainage is
        discontinued and such use ceases, classification may revert to Wetland.
        The Anderson Land Classification System includes two subcategories of
        Wetland: Forested and Nonforested.
        <br />
        <br />
        <em>Source:</em> Anderson Land Classification System{" "}
        <a
          href="https://pubs.usgs.gov/pp/0964/report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "White Supremacy",
    definition: (
      <>
        White supremacy is the idea (ideology) that white people and the ideas,
        thoughts, beliefs, and actions of white people are superior to people of
        color and their ideas, thoughts, beliefs, and actions.
        <br />
        <br />
        While most people associate white supremacy with extremist groups like
        the Ku Klux Klan and the neo-Nazis, white supremacy is ever-present in
        our institutional and cultural assumptions that assign value, morality,
        goodness, and humanity to the white group while casting people and
        communities of color as worthless, immoral, bad, and inhuman and
        "undeserving." Drawing from critical race theory, the term "white
        supremacy" also refers to a political or socio-economic system where
        white people enjoy structural advantage and rights that other racial and
        ethnic groups do not, both at a collective and an individual level.
        <br />
        <br />
        <em>Source:</em> “Racism Defined.” dRworksBook, n.d.{" "}
        <a
          href="https://www.dismantlingracism.org/racism-defined.html"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Workers in Precarious Employment",
    definition: (
      <>
        (1) workers whose contract of employment leads to classification as
        belonging to the groups of “casual workers,” “short-term workers,” or
        “seasonal workers"; (2) workers whose contract of employment allows
        employing enterprise or person to terminate the contract at short notice
        and/or at will, with the specific circumstances determined by national
        legislation and custom. In the first case, workers may be classified as
        “employees” or “own-account workers” according to the characteristics of
        the employment contract.
        <br />
        <br />
        Workers under the first category include:
        <br />● Casual workers: contracts are not expected to continue for more
        than a very short period.
        <br />● Seasonal workers: contract duration is influenced by seasonal
        factors, such as climate, public holidays, and agricultural season.
        <br />● Short-term workers: contracts are expected to last for a short
        period, but longer than those of casual workers.
        <br />
        <br />
        <em>Source:</em> "Decent Work Indicators - Guidelines for Producers and
        Users of Statistical and Legal Framework Indicators." ILO, 2013.{" "}
        <a
          href="https://www.ilo.org/stat/Publications/WCMS_223121/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Written Premium",
    definition: (
      <>
        The insurance premium registered on the books at the time a policy is
        issued and paid for.
        <br />
        <br />
        <em>Source:</em> International Risk Management Institute{" "}
        <a
          href="http://www.irmi.com/online/insurance-glossary/terms/w/written-premium.aspx"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
  {
    term: "Zero-Hours Contract",
    definition: (
      <>
        Contracts that have no guaranteed minimum number of hours.
        <br />
        <br />
        <em>Source:</em> "Non-Standard Employment Around the World:
        Understanding Challenges, Shaping Prospects." ILO, 2016.{" "}
        <a
          href="https://www.ilo.org/global/publications/books/WCMS_534496/lang--en/index.htm"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          Link
        </a>
      </>
    ),
  },
];
